export const ptBR = {
 "billing.invoice.download":"Baixar fatura em PDF",
 "billing.receipt.ownerMissing":"O PDF apresenta os valores e o pagamento registrado no Cashier. O comprovante bancário é um documento separado e deve ser solicitado ao suporte quando não estiver disponível.",
"contracts.signer":"Signatário informado",
"contracts.validatedAt":"Validação registrada em",
"contracts.evidence.MANUAL_VALIDATION":"Validação manual registrada no Stargate",
"contracts.evidence.PROVIDER_RECORDED":"Provedor de assinatura registrado",
"contracts.evidence.NOT_AVAILABLE":"Evidências de assinatura não disponíveis",
"contracts.firstPage":"Primeira página",
"contracts.lastPage":"Última página",
"contracts.previousPage":"Página anterior",
"contracts.nextPage":"Próxima página",
"contracts.pageOf":"Página {page} de {total}",
"contracts.previewError":"Não foi possível carregar o contrato. Atualize a página ou solicite ajuda ao suporte.",
"contracts.originalFile": "Contrato original registrado no Stargate",
"contracts.openOriginal": "Abrir contrato completo em PDF",
"contracts.signedFileMissing":"O cadastro contém informações de assinatura, mas o arquivo assinado e o certificado de assinatura ainda não foram disponibilizados. Solicite à Cupcode o documento completo.",

 "services.deliveryDate":"Data de entrega registrada",
  "services.view": "Ver serviço",
  "billing.phase.INITIAL_50": "Entrada · 50% inicial",
  "billing.phase.CLOSING_50": "Fechamento · 50% restante na entrega",
  "support.openTicket": "Abrir ticket",
  "support.whatsapp": "Falar no WhatsApp",

  "approvals.reasonRequired": "Informe o motivo para pedir alterações ou rejeitar",
  "approvals.deadline": "Prazo",
  "approvals.reject": "Rejeitar",
  "approvals.status.REJECTED": "Rejeitada",
  "approvals.history.REJECTED": "Versão rejeitada",
  "collaboration.files.title": "Arquivos",
  "collaboration.files.add": "Enviar arquivo",
  "collaboration.files.allowed": "PDF, imagens ou texto, até 10 MB",
  "collaboration.files.download": "Baixar",
  "collaboration.files.invalid": "Formato ou tamanho de arquivo inválido",
  "collaboration.files.uploading": "Enviando arquivo",
  "collaboration.files.scanPending": "Arquivo recebido, aguardando verificação de segurança",
  "collaboration.files.error": "Não foi possível concluir a operação com o arquivo",
  "collaboration.files.refresh": "Atualizar arquivos",
  "collaboration.requests.title": "Solicitações",
  "collaboration.requests.subtitle": "Informações e arquivos solicitados pela Cupcode",
  "collaboration.requests.empty": "Nenhuma solicitação publicada para você",
  "collaboration.requests.view": "Ver solicitação",
  "collaboration.requests.deadline": "Prazo",
  "collaboration.requests.response": "Sua resposta",
  "collaboration.requests.authorize": "Confirmo a autorização apresentada",
  "collaboration.requests.submit": "Enviar resposta",
  "collaboration.requests.submitting": "Enviando resposta",
  "collaboration.requests.submitted": "Resposta enviada para análise",
  "collaboration.requests.stale": "A solicitação mudou. Atualize antes de responder",
  "collaboration.requests.error": "Não foi possível enviar a resposta",
  "collaboration.requests.readOnly": "Consulte as informações desta solicitação",
  "collaboration.deliverables.title": "Entrega",
  "collaboration.deliverables.published": "Publicada para você",
  "collaboration.deliverables.version": "Versão",
  "collaboration.deliverables.publishedAt": "Publicada em",
  "decisions.listTitle": "Decis\u00f5es",
  "decisions.subtitle": "Escolhas que a Cupcode precisa de voc\u00ea.",
  "decisions.empty": "Nenhuma decis\u00e3o dispon\u00edvel.",
  "collaboration.deliverables.listTitle": "Entregas",
  "collaboration.deliverables.subtitle": "Entregas publicadas para voc\u00ea.",
  "collaboration.deliverables.empty": "Nenhuma entrega publicada ainda.",
  "help.title": "Central de ajuda",
  "help.subtitle": "Respostas r\u00e1pidas para as d\u00favidas mais comuns.",
  "help.empty": "Nenhum artigo dispon\u00edvel no momento.",
  "help.openCenter": "Abrir central de suporte",
  "upgrade.badge": "Upgrade dispon\u00edvel",
  "upgrade.cta": "Ver upgrade",
  "upgrade.card.title": "{service}: evolua para o {target}",
  "upgrade.card.body": "Passe do {current} para o {target} por mais {difference}.",
  "upgrade.perMonth": "/m\u00eas",
  "upgrade.perYear": "/ano",
  "upgrade.modal.title": "Upgrade de {service}",
  "upgrade.modal.description": "Do {current} para o {target}.",
  "upgrade.modal.current": "Plano atual",
  "upgrade.modal.new": "Novo plano",
  "upgrade.modal.difference": "Diferen\u00e7a",
  "upgrade.modal.note": "Enviamos o pedido para a equipe Cupcode, que confirma a mudan\u00e7a com voc\u00ea. Nenhuma cobran\u00e7a \u00e9 feita agora.",
  "upgrade.modal.noPermission": "Seu acesso n\u00e3o permite pedir upgrades. Fale com a equipe Cupcode.",
  "upgrade.modal.submit": "Solicitar upgrade",
  "upgrade.modal.cancel": "Agora n\u00e3o",
  "upgrade.sent": "Pedido de upgrade enviado.",
  "upgrade.error": "N\u00e3o foi poss\u00edvel enviar o pedido agora. Tente novamente.",
  "upgrade.request.subject": "Upgrade de {service}: {current} para {target}",
  "upgrade.request.text": "Ol\u00e1! Gostaria de fazer o upgrade de {service} do plano {current} para o {target} ({price}, {difference} a mais). Podem me ajudar com os pr\u00f3ximos passos?",
  "navigation.ads": "An\u00fancios",
  "ads.title": "An\u00fancios",
  "ads.subtitle": "Desempenho das suas campanhas de tr\u00e1fego pago.",
  "ads.demo.badge": "Dados de demonstra\u00e7\u00e3o",
  "ads.demo.note": "Estes n\u00fameros s\u00e3o ilustrativos. Vamos conectar a conta de an\u00fancios da sua empresa para mostrar os dados reais.",
  "ads.period.label": "Per\u00edodo",
  "ads.period.7": "7 dias",
  "ads.period.30": "30 dias",
  "ads.period.90": "90 dias",
  "ads.kpis": "Indicadores do per\u00edodo",
  "ads.vsPrevious": "vs. per\u00edodo anterior",
  "ads.unavailable": "N\u00e3o foi poss\u00edvel carregar os dados de an\u00fancios agora.",
  "ads.metric.spend": "Investimento",
  "ads.metric.impressions": "Impress\u00f5es",
  "ads.metric.clicks": "Cliques",
  "ads.metric.conversions": "Convers\u00f5es",
  "ads.metric.revenue": "Receita",
  "ads.metric.ctr": "CTR",
  "ads.metric.cpc": "CPC",
  "ads.metric.cpa": "CPA",
  "ads.metric.roas": "ROAS",
  "ads.chart.title": "Evolu\u00e7\u00e3o di\u00e1ria",
  "ads.chart.metric": "M\u00e9trica do gr\u00e1fico",
  "ads.chart.summary": "{metric} por dia, de {from} a {to}",
  "ads.campaigns.title": "Campanhas",
  "ads.campaigns.name": "Campanha",
  "ads.campaigns.platform": "Plataforma",
  "ads.platform.GOOGLE_ADS": "Google Ads",
  "ads.platform.META_ADS": "Meta Ads",
  "ads.status.ACTIVE": "Ativa",
  "ads.status.PAUSED": "Pausada",
  "profile.title": "Complete o perfil da sua empresa",
  "profile.description": "Leva menos de um minuto e ajuda a Cupcode a atender melhor a {company}.",
  "profile.employees.label": "Quantos funcion\u00e1rios a empresa tem?",
  "profile.employees.placeholder": "Selecione",
  "profile.employees.1": "S\u00f3 eu",
  "profile.employees.2-10": "2 a 10",
  "profile.employees.11-50": "11 a 50",
  "profile.employees.51-200": "51 a 200",
  "profile.employees.201-500": "201 a 500",
  "profile.employees.500+": "Mais de 500",
  "profile.segment.label": "Segmento de atua\u00e7\u00e3o",
  "profile.segment.placeholder": "Ex.: moda feminina, cl\u00ednica odontol\u00f3gica",
  "profile.website.label": "Site (opcional)",
  "profile.website.placeholder": "empresa.com.br",
  "profile.about.label": "O que a empresa faz, em poucas palavras (opcional)",
  "profile.save": "Salvar perfil",
  "profile.later": "Lembrar depois",
  "profile.saved": "Perfil salvo. Obrigado!",
  "profile.error.validation": "Confira os campos e tente novamente.",
  "profile.error.forbidden": "Seu acesso n\u00e3o permite editar o perfil.",
  "profile.error.unavailable": "N\u00e3o foi poss\u00edvel salvar agora. Tente novamente.",
  "agenda.title": "Agenda",
  "agenda.subtitle": "Suas pr\u00f3ximas reuni\u00f5es e os hor\u00e1rios dispon\u00edveis para agendar.",
  "agenda.upcoming.title": "Pr\u00f3ximas reuni\u00f5es",
  "agenda.upcoming.empty": "Voc\u00ea n\u00e3o tem reuni\u00f5es agendadas.",
  "agenda.duration": "{minutes} min",
  "agenda.status.SCHEDULED": "Agendada",
  "agenda.status.CONFIRMED": "Confirmada",
  "agenda.cancel": "Cancelar",
  "agenda.cancel.title": "Cancelar esta reuni\u00e3o?",
  "agenda.cancel.description": "A reuni\u00e3o de {when} ser\u00e1 cancelada e o hor\u00e1rio volta a ficar dispon\u00edvel.",
  "agenda.cancel.confirm": "Cancelar reuni\u00e3o",
  "agenda.cancel.keep": "Manter",
  "agenda.cancelled": "Reuni\u00e3o cancelada.",
  "agenda.book.title": "Agendar reuni\u00e3o",
  "agenda.book.pickDay": "Escolha um dia com hor\u00e1rios dispon\u00edveis.",
  "agenda.book.pickTime": "Hor\u00e1rios dispon\u00edveis em {day}",
  "agenda.book.noSlots": "Nenhum hor\u00e1rio dispon\u00edvel neste m\u00eas.",
  "agenda.book.topic": "Assunto (opcional)",
  "agenda.book.confirm": "Confirmar agendamento",
  "agenda.book.review.title": "Confirmar reuni\u00e3o?",
  "agenda.book.review.back": "Voltar",
  "errors.noNaveAccess.title": "Sem acesso \u00e0 Nave",
  "errors.noNaveAccess.body": "Sua conta Cupcode est\u00e1 ativa, mas ainda n\u00e3o tem acesso \u00e0 Nave. Pe\u00e7a acesso ao administrador da sua empresa ou \u00e0 equipe Cupcode, ou entre com outra conta.",
  "navigation.adsDemo": "An\u00fancios (demo)",
  "agenda.book.select": "Selecionar",
  "agenda.book.chosen": "Selecionado",
  "agenda.join": "Entrar na videochamada",
  "agenda.booked.email": "Enviamos a confirma\u00e7\u00e3o com o link da videochamada e o convite de calend\u00e1rio para o seu e-mail.",
  "support.sender.you": "Voc\u00ea",
  "support.conversation.waitingCupcode": "A equipe da Cupcode vai responder por aqui. Voc\u00ea tamb\u00e9m recebe um aviso quando chegar a resposta.",
  "support.conversation.waitingClient": "A equipe respondeu e aguarda voc\u00ea. Responda abaixo para continuar.",
  "support.conversation.closed": "Este chamado foi encerrado. Se precisar, responda abaixo para reabrir a conversa.",
  "support.reply.placeholder": "Escreva sua resposta\u2026",
  "support.reply.hint": "Ctrl + Enter para enviar",
  "upgrade.progress.label": "Etapas do upgrade",
  "upgrade.progress.sign": "Assinar o contrato",
  "upgrade.progress.signed": "Contrato assinado",
  "upgrade.progress.signDetail": "Enviamos o contrato para {email}. Abra o e-mail, confira os termos e assine.",
  "upgrade.progress.signSendFailed": "N\u00e3o conseguimos enviar o e-mail do contrato agora. Tente enviar de novo.",
  "upgrade.progress.send": "Enviar contrato por e-mail",
  "upgrade.progress.resend": "Reenviar e-mail",
  "upgrade.progress.pay": "Pagar {amount}",
  "upgrade.progress.paid": "Pagamento confirmado",
  "upgrade.progress.payDetail": "Diferen\u00e7a proporcional do upgrade. Assim que o pagamento for confirmado, o novo plano passa a valer.",
  "upgrade.progress.payNow": "Pagar {amount}",
  "upgrade.progress.activate": "Plano {target} ativo",
  "upgrade.progress.active": "Plano {target} ativo",
  "upgrade.progress.activeDetail": "Nossa equipe j\u00e1 foi avisada e vai configurar tudo com voc\u00ea.",
  "upgrade.progress.checkInbox": "N\u00e3o achou o e-mail? Olhe tamb\u00e9m a caixa de spam.",
  "upgrade.progress.sent": "Contrato enviado por e-mail.",
  "upgrade.progress.close": "Fechar",
  "upgrade.status.badge": "Upgrade em andamento",
  "upgrade.status.badgeActive": "Upgrade ativo",
  "upgrade.status.sign": "Assine o contrato do {target}",
  "upgrade.status.signBody": "Enviamos o contrato por e-mail. Falta s\u00f3 assinar.",
  "upgrade.status.pay": "Pague {amount} para ativar o {target}",
  "upgrade.status.payBody": "Contrato assinado. O novo plano come\u00e7a assim que o pagamento for confirmado.",
  "upgrade.status.active": "{target} ativo",
  "upgrade.status.activeBody": "Pagamento confirmado. Nossa equipe vai configurar tudo com voc\u00ea.",
  "upgrade.status.ctaSign": "Ver passos",
  "upgrade.status.ctaPay": "Pagar agora",
  "upgrade.status.ctaActive": "Ver detalhes",
  "upgrade.self.cta": "Contratar upgrade",
  "upgrade.self.step1": "Voc\u00ea contrata e o contrato vai para o e-mail do representante legal ({email}).",
  "upgrade.self.step2": "Ele \u00e9 assinado digitalmente, com verifica\u00e7\u00e3o por c\u00f3digo.",
  "upgrade.self.step3": "Voc\u00ea paga {amount}, a diferen\u00e7a proporcional dos {remaining} dias que restam do ciclo.",
  "upgrade.self.step4": "O plano muda para o {target} e nossa equipe configura tudo com voc\u00ea.",
  "upgrade.self.error.changed": "O valor mudou. Confira o novo valor e confirme de novo.",
  "upgrade.self.error.inProgress": "J\u00e1 existe um upgrade em andamento para este servi\u00e7o.",
  "upgrade.self.error.noRepresentative": "N\u00e3o encontramos o representante legal da empresa. Fale com a equipe para concluir o upgrade.",
  "upgrade.self.error.contract": "N\u00e3o conseguimos preparar o contrato agora. Tente de novo ou pe\u00e7a pelo suporte.",
  "upgrade.quote.now": "Para trocar agora",
  "upgrade.quote.nowDetail": "Diferen\u00e7a proporcional: {remaining} de {total} dias restantes do ciclo atual",
  "upgrade.quote.from": "A partir de {date}",
  "upgrade.quote.fromDetail": "Valor do {target} em cada ciclo",
  "upgrade.modal.step3Quote": "Depois da confirma\u00e7\u00e3o, voc\u00ea paga {amount} e o novo plano passa a valer. Nada \u00e9 cobrado agora.",
  "upgrade.request.quote": "Valor proporcional informado no portal: {amount} ({remaining} de {total} dias do ciclo atual); valor cheio a partir de {date}.",
  "upgrade.includes.keptCount": "Ver os {count} itens que continuam com voc\u00ea",
  "upgrade.includes.titleCompare": "O que voc\u00ea ganha no {target}",
  "upgrade.includes.titleAll": "O que o {target} inclui",
  "upgrade.includes.new": "Novo",
  "questionnaires.draftSaved": "Rascunho salvo.",
  "questionnaires.completed": "Question\u00e1rio conclu\u00eddo. Obrigado!",
  "approvals.reasonMissing": "Escreva o motivo no coment\u00e1rio antes de pedir altera\u00e7\u00f5es ou rejeitar.",
  "profile.cta": "Completar perfil",
  "upgrade.modal.yourPlan": "Seu plano",
  "upgrade.modal.how": "Como funciona",
  "upgrade.modal.step1": "Voc\u00ea envia o pedido por aqui.",
  "upgrade.modal.step2": "A equipe Cupcode confirma os detalhes com voc\u00ea.",
  "upgrade.modal.step3": "O plano s\u00f3 muda depois da sua confirma\u00e7\u00e3o. Nada \u00e9 cobrado agora.",
  "home.attention.cta.review": "Revisar",
  "home.attention.cta.choose": "Escolher",
  "home.attention.cta.respond": "Responder",
  "home.attention.cta.open": "Abrir",
  "collaboration.files.none": "Nenhum arquivo anexado.",
  "collaboration.files.choose": "Escolher arquivo",
  "notifications.subtitle": "Avisos sobre pagamentos e atualiza\u00e7\u00f5es da sua conta.",
  "notifications.refresh": "Atualizar",
  "notifications.unreadCount.one": "{count} n\u00e3o lida",
  "notifications.unreadCount.other": "{count} n\u00e3o lidas",
  "agenda.legend.title": "Legenda do calend\u00e1rio",
  "agenda.legend.available": "Dispon\u00edvel",
  "agenda.legend.holiday": "Feriado",
  "agenda.legend.selected": "Selecionado",
  "agenda.holiday.newYear": "Confraterniza\u00e7\u00e3o Universal",
  "agenda.holiday.carnival": "Carnaval",
  "agenda.holiday.goodFriday": "Sexta-feira Santa",
  "agenda.holiday.tiradentes": "Tiradentes",
  "agenda.holiday.labour": "Dia do Trabalho",
  "agenda.holiday.corpusChristi": "Corpus Christi",
  "agenda.holiday.independence": "Independ\u00eancia do Brasil",
  "agenda.holiday.ourLady": "Nossa Senhora Aparecida",
  "agenda.holiday.allSouls": "Finados",
  "agenda.holiday.republic": "Proclama\u00e7\u00e3o da Rep\u00fablica",
  "agenda.holiday.blackAwareness": "Consci\u00eancia Negra",
  "agenda.holiday.christmas": "Natal",
  "agenda.book.selected": "{day} \u00e0s {time} \u00b7 {minutes} min",
  "agenda.book.timezone": "Hor\u00e1rios no fuso {zone}.",
  "agenda.book.notice": "Agende com pelo menos {hours} h de anteced\u00eancia.",
  "agenda.booked": "Reuni\u00e3o agendada: {when}.",
  "agenda.book.noPermission": "Seu acesso n\u00e3o permite agendar reuni\u00f5es. Fale com a equipe Cupcode.",
  "agenda.error.taken": "Esse hor\u00e1rio acabou de ser ocupado. Escolha outro.",
  "agenda.error.validation": "Confira os dados e tente novamente.",
  "agenda.error.forbidden": "Seu acesso n\u00e3o permite esta a\u00e7\u00e3o.",
  "agenda.error.unavailable": "N\u00e3o foi poss\u00edvel concluir agora. Tente novamente.",
  "agenda.unavailable": "N\u00e3o foi poss\u00edvel carregar a agenda agora.",
  "calendar.previous": "M\u00eas anterior",
  "calendar.next": "Pr\u00f3ximo m\u00eas",
  "agenda.admin.title": "Disponibilidade da equipe",
  "agenda.admin.description": "Defina os dias e hor\u00e1rios em que os clientes podem agendar reuni\u00f5es.",
  "agenda.admin.weekday": "Dia da semana",
  "agenda.admin.start": "In\u00edcio",
  "agenda.admin.end": "Fim",
  "agenda.admin.slot": "Dura\u00e7\u00e3o",
  "agenda.admin.active": "Ativo",
  "agenda.admin.slotMinutes": "{minutes} min",
  "agenda.admin.addRule": "Adicionar hor\u00e1rio",
  "agenda.admin.removeRule": "Remover hor\u00e1rio",
  "agenda.admin.empty": "Nenhum hor\u00e1rio definido. Os clientes n\u00e3o conseguem agendar.",
  "agenda.admin.blocks": "Datas bloqueadas",
  "agenda.admin.blockDate": "Data",
  "agenda.admin.blockReason": "Motivo (opcional)",
  "agenda.admin.addBlock": "Bloquear data",
  "agenda.admin.removeBlock": "Remover bloqueio",
  "agenda.admin.save": "Salvar disponibilidade",
  "agenda.admin.saved": "Disponibilidade salva.",
  "navigation.group.work": "Colabora\u00e7\u00e3o",
  "navigation.group.commercial": "Financeiro e contratos",
  "navigation.group.service": "Atendimento",
  "collaboration.requests.status.WAITING_CLIENT": "Aguardando sua resposta",
  "collaboration.requests.status.SUBMITTED": "Enviada para análise",
  "collaboration.requests.status.UNDER_REVIEW": "Em análise",
  "collaboration.requests.status.COMPLETED": "Concluída",
  "collaboration.requests.status.CANCELLED": "Cancelada",
  "collaboration.requests.status.EXPIRED": "Expirada",
  "collaboration.requests.status.SUPERSEDED": "Substituída",

  "documents.download": "Baixar documento",
  "documents.downloadError": "Não foi possível baixar o documento",
  "documents.version": "Versão",
  "questionnaires.choose": "Escolha uma opção",
  "questionnaires.submit": "Concluir questionário",
  "questionnaires.versionConflict": "A versão mudou. Atualize o questionário antes de responder",
  "questionnaires.required": "Preencha os campos obrigatórios",
  "questionnaires.submitError": "Não foi possível salvar suas respostas",
  "questionnaires.save": "Salvar rascunho",

  "contracts.status.PENDING_SIGNATURE": "Aguardando assinatura",
  "contracts.status.SUPERSEDED": "Substituído",
  "contracts.status.CANCELLED": "Cancelado",

  "billing.service": "Serviço contratado",
  "billing.plan": "Plano",
  "billing.contract": "Contrato",
  "billing.competence": "Competência",
  "billing.period.title": "Período de cobrança",
  "billing.subtotal": "Subtotal",
  "billing.additions": "Acréscimos",
  "billing.amountPaid": "Valor pago",
  "billing.payment.title": "Pagamento",
  "billing.payment.explanation": "Conclua o pagamento no checkout seguro do Cashier. Ao retornar, consulte o status atualizado.",
  "billing.payment.cashier": "Pagar no Cashier",
  "billing.payment.unavailable": "O pagamento desta fatura está temporariamente indisponível. Entre em contato com o suporte.",
  "billing.payment.refresh": "Atualizar status",
  "billing.history.title": "Pagamentos confirmados",
  "billing.history.empty": "Nenhum pagamento confirmado nesta fatura.",
  "billing.method.PIX": "Pix",
  "billing.method.CARD": "Cartão",
  "billing.method.BOLETO": "Boleto",

  "platform.admin": "Administração da plataforma",
  "platform.search": "Buscar organização",
  "platform.viewing": "Visualizando: {organization}",
  "platform.return": "Sair da visualização",
  "organization.switchFailed": "Não foi possível trocar de organização. Tente novamente.",

  "app.name": "Nave",
  "app.tagline": "Seu espaço Cupcode",
  "navigation.home": "Início",
  "navigation.foundation": "Foundation V0.1",
  "organization.label": "Organização",
  "organization.switch": "Trocar organização",
  "organization.single": "Organização ativa",
  "language.label": "Idioma",
  "language.ptBR": "Português",
  "language.en": "English",
  "language.es": "Español",
  "theme.label": "Tema",
  "theme.light": "Claro",
  "theme.dark": "Escuro",
  "scenario.label": "Cenário de desenvolvimento",
  "user.menu": "Menu da conta",
  "user.emailUnavailable": "E-mail indisponível",
  "production.unavailable.title": "Nave indisponível neste ambiente",
  "production.unavailable.body": "As integrações de produção necessárias ainda não estão configuradas. Nenhum dado de demonstração será usado como substituto.",
  "production.profileUnavailable.title": "Sua sessão foi reconhecida",
  "production.profileUnavailable.body": "Não foi possível carregar sua organização e os dados de cliente com segurança. Nenhum dado de demonstração será exibido.",
  "publicHome.title": "Bem-vindo à sua Nave Cupcode",
  "publicHome.description": "Acompanhe seus projetos, serviços, documentos, financeiro e suporte em uma experiência única.",
  "publicHome.signIn": "Entrar com a Cupcode",
  "publicHome.loginUnavailable": "Não foi possível iniciar o login. Tente novamente em instantes.",
  "publicHome.returnNotice": "Depois da entrada, você voltará para a página solicitada.",
  "production.organization.choose": "Escolha uma organização",
  "production.organization.none": "Nenhuma organização ativa está vinculada à sua conta.",
  "production.dashboard.sections": "Dados da sua organização",
  "production.dashboard.services": "Serviços",
  "production.dashboard.projects": "Projetos",
  "production.dashboard.integrationUnavailable": "Ainda não foi possível carregar dados reais desta área.",
  "production.dashboard.loading": "Carregando dados da sua organização…",
  "production.dashboard.projectsEmpty": "Nenhum projeto publicado para você está disponível para o cliente selecionado.",
  "production.project.back": "Voltar para Projetos e Serviços",
  "services.status.PAUSED": "Pausado",
  "services.status.COMPLETED": "Concluído",
  "services.status.ENDED": "Encerrado",
  "services.status.UNAVAILABLE": "Status indisponível",
  "account.authRequired.title": "Entre para continuar",
  "account.authRequired.body": "Sua sessão não está autenticada. Entre pelo Cupcode Accounts para continuar na Nave.",
  "account.authRequired.afterLogoutBody": "Sua sessão local da Nave foi encerrada. Entre novamente para continuar.",
  "account.sessionExpired.title": "Sua sessão expirou",
  "account.sessionExpired.body": "Por segurança, é necessário entrar novamente para continuar.",
  "account.loginCancelled.title": "Entrada cancelada",
  "account.loginCancelled.body": "A entrada foi cancelada. Você pode tentar novamente quando quiser.",
  "account.actions.signIn": "Entrar",
  "account.actions.signOut": "Sair",
  "account.actions.signInAgain": "Entrar novamente",
  "account.actions.restart": "Reiniciar entrada",
  "account.authAction.notConnected": "A conexão com o Cupcode Accounts será ativada em uma etapa posterior da integração.",
  "account.callback.title": "Validando sua entrada",
  "account.callback.body": "Estamos concluindo a verificação antes de abrir sua experiência na Nave.",
  "account.callback.loading": "Validando entrada",
  "organization.selection.title": "Escolha uma organização",
  "organization.selection.description": "Selecione uma organização disponível para continuar.",
  "organization.selection.label": "Organização disponível",
  "organization.selection.placeholder": "Selecione uma organização",
  "organization.selection.continue": "Continuar",
  "organization.unavailable.title": "Organização indisponível",
  "organization.unavailable.body": "Não foi possível disponibilizar essa organização com segurança neste momento.",
  "errors.accountsUnavailable.title": "Serviço de conta temporariamente indisponível",
  "errors.accountsUnavailable.body": "Não foi possível confirmar sua conta agora. Tente novamente mais tarde.",
  "errors.membershipRequired.title": "Acesso de cliente não encontrado",
  "errors.membershipRequired.body": "Sua conta está autenticada, mas não há um acesso de cliente elegível disponível na Nave.",
  "errors.invalidEntryContext.title": "Não foi possível validar esta entrada",
  "errors.invalidEntryContext.body": "O acesso recebido não é válido ou não pode ser usado com segurança. Inicie o fluxo novamente.",
  "errors.expiredEntryContext.title": "Esta entrada expirou",
  "errors.expiredEntryContext.body": "O acesso expirou e precisa ser iniciado novamente.",
  "errors.resourceConflict.title": "Esta ação não está mais disponível",
  "errors.resourceConflict.body": "O estado deste item mudou. Atualize a experiência antes de tentar novamente.",
  "home.health.READY": "Atualizado",
  "home.health.PARTIAL": "Parcial",
  "home.health.STALE": "Pode estar desatualizado",
  "home.health.UNAVAILABLE": "Indisponível",
  "priority.LOW": "Baixa",
  "priority.NORMAL": "Normal",
  "priority.HIGH": "Alta",
  "priority.CRITICAL": "Crítica",
  "services.status.ACTIVE": "Ativo",
  "products.name.telescup": "Telescup",
  "products.name.aidar-seo": "AiDAR SEO",
  "products.name.aidar-copy": "AiDAR Copy",
  "products.name.cupcode-host": "Cupcode Host",
  "products.title": "Produtos",
  "products.empty": "Nenhum produto digital contratado está disponível para o cliente selecionado.",
  "products.plan": "Plano / referência",
  "products.limits": "Limites contratados",
  "products.open": "Abrir produto",
  "products.access.ALLOWED": "Acesso autorizado para este usuário.",
  "products.access.DENIED": "Você não possui acesso a este aplicativo.",
  "products.access.UNAVAILABLE": "Não foi possível confirmar seu acesso a este aplicativo agora.",
  "products.status.ACTIVE": "Ativo",
  "products.status.INACTIVE": "Inativo",
  "products.status.SUSPENDED": "Suspenso",
  "activity.generic": "Atualização disponível",
  "home.greeting": "Visão geral",
  "home.subtitle": "O que precisa da sua atenção e o que está acontecendo agora.",
  "home.attention.title": "Precisa de você",
  "home.attention.empty": "Nada precisa da sua ação agora.",
  "home.progress.title": "Em andamento",
  "home.progress.empty": "Nenhum projeto ou serviço em andamento.",
  "home.billing.title": "Financeiro",
  "home.billing.empty": "Nenhuma cobrança relevante agora.",
  "home.usage.title": "Produtos e uso",
  "home.usage.empty": "Nenhum alerta de uso relevante.",
  "home.support.title": "Suporte",
  "home.support.empty": "Nenhum atendimento ativo relevante.",
  "home.activity.title": "Atividade recente",
  "home.activity.empty": "Nenhuma atividade recente.",
  "state.loading": "Carregando…",
  "state.stale": "Os dados podem estar desatualizados.",
  "state.unavailable": "Esta seção está temporariamente indisponível.",
  "state.partial": "Algumas informações estão temporariamente indisponíveis.",
  "section.state.READY": "Disponível",
  "section.state.STALE": "Desatualizado",
  "section.state.EMPTY": "Vazio",
  "section.state.UNAVAILABLE": "Indisponível",
  "errors.generic.title": "Não foi possível carregar esta área",
  "errors.generic.body": "Tente novamente ou continue usando as outras áreas disponíveis.",
  "errors.forbidden.title": "Acesso indisponível",
  "errors.forbidden.body": "Este conteúdo não está disponível para o seu acesso atual.",
  "errors.unavailable.title": "Serviço temporariamente indisponível",
  "errors.unavailable.body": "Uma dependência necessária não respondeu. As outras áreas continuam disponíveis quando possível.",
  "errors.notFound.title": "Página não encontrada",
  "errors.notFound.body": "O endereço pode estar incorreto ou a página ainda não existe nesta versão.",
  "errors.notFound.back": "Voltar para o início",
  "billing.nextInvoice": "Próxima cobrança",
  "billing.overdue": "Vencida",
  "billing.open": "Em aberto",
  "billing.due": "Vencimento",
  "navigation.billing": "Financeiro",
  "navigation.support": "Suporte",
  "billing.page.title": "Financeiro",
  "billing.page.subtitle": "Consulte suas faturas e os valores informados pelo sistema financeiro da Cupcode.",
  "billing.summary.title": "Situação financeira",
  "billing.summary.open": "Em aberto",
  "billing.summary.overdue": "Vencidas",
  "client.label": "Cliente",
  "client.search": "Buscar cliente",
  "client.choose": "Selecionar cliente",
  "client.selectionRequired": "Selecione um cliente acima para consultar suas informações.",
  "client.test": "Cliente de teste",
  "billing.noFinancialAccount": "Selecione um cliente para consultar seu financeiro. As outras áreas continuam disponíveis.",
  "billing.summary.clear": "Tudo certo com suas cobranças neste momento.",
  "billing.invoices.title": "Faturas",
  "billing.invoices.empty": "Nenhuma fatura disponível para o cliente selecionado.",
  "billing.invoices.loadMore": "Carregar mais faturas",
  "billing.invoices.loadingMore": "Carregando mais faturas…",
  "billing.invoices.loadMoreError": "Não foi possível carregar mais faturas agora.",
  "billing.invoice.label": "Fatura",
  "billing.invoice.view": "Ver fatura",
  "billing.invoice.detailTitle": "Fatura {id}",
  "billing.invoice.summary": "Resumo da fatura",
  "billing.invoice.status.open": "Em aberto",
  "billing.invoice.status.overdue": "Vencida",
  "billing.invoice.status.paid": "Paga",
  "billing.invoice.status.cancelled": "Cancelada",
  "billing.payment.status.pending": "Pendente",
  "billing.payment.status.processing": "Em processamento",
  "billing.payment.status.paid": "Pago",
  "billing.payment.status.failed": "Falhou",
  "billing.payment.status.cancelled": "Cancelado",
  "billing.payment.status.refunded": "Reembolsado",
  "billing.total": "Valor total",
  "billing.balance": "Saldo",
  "billing.paymentStatus": "Status do pagamento",
  "billing.issuedAt": "Emitida em",
  "billing.paidAt": "Paga em",
  "billing.items.title": "Itens da fatura",
  "billing.period.unspecified": "Período não informado",
  "billing.errors.forbidden.title": "Financeiro indisponível para este acesso",
  "billing.errors.forbidden.body": "Seu acesso atual não permite consultar as informações financeiras desta organização.",
  "billing.errors.notFound.title": "Fatura não encontrada",
  "billing.errors.notFound.body": "Esta fatura não está disponível para o cliente selecionado ou para o seu escopo de acesso.",
  "billing.errors.unavailable.title": "Financeiro temporariamente indisponível",
  "billing.errors.unavailable.body": "Não foi possível consultar o sistema financeiro agora. As outras áreas da Nave continuam disponíveis.",
  "billing.errors.generic.title": "Não foi possível carregar o Financeiro",
  "billing.errors.generic.body": "Ocorreu um erro inesperado ao carregar esta área.",
  "projects.status.IN_PROGRESS": "Em andamento",
  "projects.status.WAITING_CLIENT": "Aguardando você",
  "projects.status.COMPLETED": "Concluído",
  "projects.stage.development": "Desenvolvimento",
  "usage.threshold.SOFT_LIMIT": "Próximo do limite",
  "usage.threshold.HARD_LIMIT": "Limite atingido",
  "usage.title": "Uso do produto",
  "usage.empty": "Nenhuma métrica de uso disponível para este produto.",
  "usage.unavailable": "Os dados de uso deste produto estão temporariamente indisponíveis.",
  "usage.used": "Usado",
  "usage.included": "Incluído",
  "usage.remaining": "Restante",
  "usage.softLimit": "Limite de atenção",
  "usage.hardLimit": "Limite máximo",
  "usage.overage": "Excedente",
  "usage.periodStart": "Início do período",
  "usage.periodEnd": "Fim do período",
  "usage.resetAt": "Renovação do período",
  "usage.updatedAt": "Atualizado em",
  "usage.metric.storage": "Armazenamento",
  "usage.metric.analyses": "Análises",
  "usage.unit.analysis.one": "análise",
  "usage.unit.analysis.other": "análises",
  "usage.limit.SOFT_LIMIT": "Atenção ao limite",
  "usage.limit.HARD_LIMIT": "Limite atingido",
  "attention.action.project": "Projeto aguardando sua ação",
  "attention.action.support": "Responder ao suporte",
  "activity.invoicePaid": "Pagamento confirmado",
  "usage.assets": "Ativos",
  "usage.storage": "Armazenamento",
  "usage.unit.assets.one":"ativo",
  "usage.unit.assets.other":"ativos",
  "usage.unit.credits.one":"crédito",
  "usage.unit.credits.other":"créditos",
  "usage.monitoredUrls": "URLs monitoradas",
  "usage.aiCredits": "Créditos de IA",
  "support.reply.title": "Responder ao chamado",
  "support.create.title": "Novo chamado",
  "support.create.noServices": "Não há serviços disponíveis para abrir um chamado neste cliente.",
  "support.create.service": "Serviço",
  "support.create.subject": "Assunto",
  "support.message": "Mensagem",
  "support.sending": "Enviando…",
  "support.reply.send": "Enviar resposta",
  "support.create.send": "Abrir chamado",
  "support.validation": "Confira o assunto e a mensagem antes de enviar.",
  "support.conflict": "Esta tentativa já foi enviada com outro conteúdo. Atualize o chamado antes de tentar novamente.",
  "notifications.title":"Notificações",
  "notifications.unavailable.title":"Notificações temporariamente indisponíveis",
  "notifications.unavailable.body":"Não foi possível consultar suas notificações agora. As outras áreas continuam disponíveis.",
  "notifications.empty":"Você não tem notificações disponíveis para este cliente.",
  "notifications.read":"Lida",
  "notifications.unread":"Não lida",
  "notifications.markRead":"Marcar como lida",
  "notifications.partial":"Mostrando notificações dos pagamentos recentes.",
  "support.attachments":"Anexos",
  "support.download":"Baixar arquivo",
  "support.chooseFile":"Selecionar arquivo",
  "support.upload":"Enviar arquivo",
  "support.attachmentError":"O arquivo não está disponível agora. Confira o tipo e o tamanho ou aguarde a verificação de segurança.",
  "support.attachment.pending":"Envio pendente",
  "support.attachment.stored":"Arquivo recebido",
  "support.attachment.clean":"Verificação concluída",
  "support.attachment.blocked":"Arquivo bloqueado",
  "support.attachment.error":"Falha na verificação",
  "support.help":"Central de ajuda",
  "support.helpEmpty":"Não há artigos publicados disponíveis agora.",
  "support.readArticle":"Ler artigo",
  "support.finalize":"Confirmar resolução",
  "support.reopen":"Reabrir chamado",
  "support.actionError":"Não foi possível alterar este chamado. Atualize para confirmar o estado atual.",
  "support.conversation":"Conversa",
  "support.sender.CLIENT":"Cliente",
  "support.sender.CUPCODE":"Cupcode",
  "support.moreMessages":"As 100 mensagens mais recentes estão disponíveis nesta conversa.",
  "support.page.title": "Suporte",
  "support.page.subtitle": "Acompanhe os chamados disponíveis para o cliente selecionado e veja quem está aguardando a próxima atualização.",
  "support.summary.title": "Acompanhamento recente",
  "support.tickets.title": "Chamados",
  "support.tickets.empty": "Nenhum chamado disponível para o cliente selecionado.",
  "support.tickets.moreAvailable": "Há outros chamados além dos exibidos nesta página.",
  "support.tickets.loadMore": "Carregar mais chamados",
  "support.tickets.loadingMore": "Carregando mais chamados…",
  "support.tickets.loadMoreError": "Não foi possível carregar mais chamados agora.",
  "support.ticket.label": "Chamado",
  "support.ticket.view": "Ver chamado",
  "support.ticket.summary": "Resumo do chamado",
  "support.lastActivity": "Última atividade",
  "support.awaiting": "Aguardando",
  "support.awaiting.CUPCODE": "Cupcode",
  "support.awaiting.CLIENT": "Você",
  "support.awaiting.NONE": "Ninguém",
  "support.unread": "Não lidas",
  "support.serviceRef": "Serviço relacionado",
  "support.errors.forbidden.title": "Suporte indisponível para este acesso",
  "support.errors.forbidden.body": "Seu acesso atual não permite consultar os chamados do cliente selecionado.",
  "support.errors.notFound.title": "Chamado não encontrado",
  "support.errors.notFound.body": "Este chamado não está disponível para o cliente selecionado ou para o seu escopo de acesso.",
  "support.errors.unavailable.title": "Suporte temporariamente indisponível",
  "support.errors.unavailable.body": "Não foi possível consultar o sistema de suporte agora. As outras áreas da Nave continuam disponíveis.",
  "support.errors.generic.title": "Não foi possível carregar o Suporte",
  "support.errors.generic.body": "Ocorreu um erro inesperado ao carregar esta área.",
  "support.status.WAITING_CUPCODE": "Aguardando Cupcode",
  "support.status.WAITING_CLIENT": "Aguardando você",
  "support.status.IN_PROGRESS": "Em atendimento",
  "support.status.RESOLVED": "Resolvido",
  "support.status.CLOSED": "Fechado",
  "attention.action.approval": "Aprovação pendente",
  "attention.action.clientRequest": "Informação solicitada",
  "attention.action.payInvoice": "Fatura vencida",
  "activity.project.stageChanged": "O projeto avançou de etapa",
  "common.updatedAt": "Atualizado",
  "common.items": "itens",
  "common.open": "Abrir",
  "common.action": "Ação necessária",
  "common.attention": "Atenção",
  "common.information": "Informação",
  "navigation.projectsServices": "Projetos e Serviços",
  "navigation.documents": "Documentos",
  "projectsServices.title": "Projetos e Serviços",
  "projectsServices.subtitle": "Acompanhe seus projetos e os serviços ativos em um só lugar.",
  "projects.title": "Projetos",
  "projects.empty": "Você não possui projetos em andamento neste momento.",
  "projects.view": "Ver projeto",
  "projects.progress": "Andamento",
  "projects.currentStage": "Etapa atual",
  "projects.nextStage": "Próxima etapa",
  "projects.nextMilestone": "Próximo marco",
  "projects.committedDate": "Data comprometida",
  "projects.requests": "Solicitações",
  "projects.requestsCount.one": "{count} solicitação relacionada.",
  "projects.requestsCount.other": "{count} solicitações relacionadas.",
  "projects.approvals": "Aprovações",
  "projects.approvalsCount.one": "{count} aprovação relacionada.",
  "projects.approvalsCount.other": "{count} aprovações relacionadas.",
  "projects.activity": "Atividade recente",
  "services.title": "Serviços",
  "services.empty": "Nenhum serviço disponível para o cliente selecionado.",
  "documents.title": "Documentos",
  "documents.subtitle": "Contratos e propostas disponíveis para o cliente selecionado.",
  "documents.reference": "Documento relacionado",
  "contracts.title": "Contratos",
  "contracts.untitled": "Contrato",
  "contracts.empty": "Nenhum contrato disponível.",
  "contracts.view": "Ver contrato",
  "contracts.signedAt": "Assinado em",
  "contracts.startsAt": "Início",
  "contracts.endsAt": "Fim",
  "proposals.title": "Propostas",
  "proposals.empty": "Nenhuma proposta disponível.",
  "proposals.view": "Ver proposta",
  "proposals.createdAt": "Criada em",
  "proposals.expiresAt": "Validade",
  "questionnaires.title": "Questionários",
  "questionnaires.subtitle": "Revise questionários disponíveis a partir de solicitações e links autorizados.",
  "questionnaires.empty": "Nenhum questionário disponível.",
  "questionnaires.dueAt": "Prazo",
  "questionnaires.review": "Revisar",
  "questionnaires.progress": "Progresso",
  "questionnaires.respondDeferred": "Este questionário pode exigir sua resposta, mas a edição real permanece no sistema responsável.",
  "questionnaires.readOnly": "Este questionário está disponível somente para revisão.",
  "common.back": "Voltar",
  "common.retry": "Tentar novamente",
  "status.unknown": "Status disponível",
  "projects.status.NOT_STARTED": "Não iniciado",
  "projects.status.WAITING_CUPCODE": "Aguardando Cupcode",
  "projects.status.UNDER_REVIEW": "Em revisão",
  "projects.status.SCHEDULED": "Agendado",
  "projects.status.CANCELLED": "Cancelado",
  "contracts.status.ACTIVE": "Ativo",
  "contracts.status.SIGNED": "Assinado",
  "contracts.status.EXPIRED": "Encerrado",
  "proposals.status.OPEN": "Aberta",
  "proposals.status.ACCEPTED": "Aceita",
  "proposals.status.EXPIRED": "Expirada",
  "questionnaires.status.OPEN": "Aberto",
  "questionnaires.status.IN_PROGRESS": "Em andamento",
  "questionnaires.status.COMPLETED": "Concluído",
  "approvals.eyebrow": "Colaboração",
  "approvals.title": "Aprovações",
  "approvals.subtitle": "Revise versões submetidas e registre sua decisão quando uma ação estiver disponível.",
  "approvals.empty": "Nenhuma aprovação disponível para o cliente selecionado.",
  "approvals.view": "Ver aprovação",
  "approvals.untitled": "Aprovação",
  "approvals.version": "Versão {version}",
  "approvals.versionLabel": "Versão",
  "approvals.currentVersion": "Versão atual",
  "approvals.requestedAt": "Solicitada em",
  "approvals.completedAt": "Concluída em",
  "approvals.artifactVersion": "Versão do artefato",
  "approvals.actionsLabel": "Ações da aprovação",
  "approvals.actionVersionNotice": "Sua decisão será registrada para a versão {version}.",
  "approvals.commentOptional": "Comentário opcional",
  "approvals.approve": "Aprovar esta versão",
  "approvals.requestChanges": "Solicitar alterações",
  "approvals.submitting": "Registrando sua decisão…",
  "approvals.success": "Decisão registrada com sucesso.",
  "approvals.stale": "Esta aprovação mudou desde que você abriu a tela. Atualize antes de responder.",
  "approvals.ownerUnavailable": "Esta aprovação pertence a outro sistema e não pode ser respondida por aqui agora.",
  "approvals.actionError": "Não foi possível registrar sua decisão agora.",
  "approvals.readOnly": "Esta aprovação está disponível somente para consulta neste momento.",
  "approvals.externalOwnerReadOnly": "Esta aprovação é controlada pelo sistema responsável e está disponível somente para consulta aqui.",
  "approvals.history": "Histórico",
  "approvals.evidence": "Evidência da decisão",
  "approvals.history.VERSION_SUBMITTED": "Versão submetida",
  "approvals.history.APPROVED": "Versão aprovada",
  "approvals.history.CHANGES_REQUESTED": "Alterações solicitadas",
  "approvals.history.SUPERSEDED": "Aprovação substituída",
  "approvals.history.CANCELLED": "Aprovação cancelada",
  "approvals.status.READY": "Pronta para envio",
  "approvals.status.WAITING_CLIENT": "Aguardando você",
  "approvals.status.APPROVED": "Aprovada",
  "approvals.status.CHANGES_REQUESTED": "Alterações solicitadas",
  "approvals.status.SUPERSEDED": "Substituída",
  "approvals.status.CANCELLED": "Cancelada",
  "approvals.subject.homepage": "Homepage do site",
  "activity.approval.approved": "Você aprovou uma versão",
  "activity.approval.changesRequested": "Voc\u00ea solicitou altera\u00e7\u00f5es em uma vers\u00e3o",
  "attention.action.decision": "Uma decis\u00e3o precisa de voc\u00ea",
  "requests.decision.title": "Escolha necess\u00e1ria",
  "requests.decision.description": "Revise as op\u00e7\u00f5es e registre sua escolha.",
  "feedback.title": "Feedback",
  "feedback.subtitle": "Converse sobre este contexto sem alterar a decis\u00e3o formal.",
  "feedback.empty": "Ainda n\u00e3o h\u00e1 coment\u00e1rios vis\u00edveis para voc\u00ea.",
  "feedback.commentLabel": "Seu coment\u00e1rio",
  "feedback.submit": "Enviar coment\u00e1rio",
  "feedback.submitting": "Enviando coment\u00e1rio\u2026",
  "feedback.success": "Coment\u00e1rio enviado.",
  "feedback.unavailable": "N\u00e3o conseguimos carregar este feedback agora.",
  "feedback.ownerUnavailable": "Este feedback pertence a outro sistema e n\u00e3o pode ser enviado por aqui agora.",
  "feedback.closed": "Esta conversa n\u00e3o aceita novos coment\u00e1rios.",
  "feedback.validation": "Escreva um coment\u00e1rio antes de enviar.",
  "feedback.error": "N\u00e3o foi poss\u00edvel enviar seu coment\u00e1rio agora.",
  "feedback.externalReadOnly": "Este feedback \u00e9 controlado pelo sistema respons\u00e1vel e est\u00e1 dispon\u00edvel somente para consulta aqui.",
  "feedback.readOnly": "Este feedback est\u00e1 dispon\u00edvel somente para consulta neste momento.",
  "feedback.status.OPEN": "Aberto",
  "feedback.status.RESOLVED": "Resolvido",
  "feedback.status.CANCELLED": "Cancelado",
  "feedback.author.YOU": "Voc\u00ea",
  "feedback.author.CUSTOMER": "Cliente",
  "feedback.author.CUPCODE": "Cupcode",
  "decisions.eyebrow": "Colabora\u00e7\u00e3o",
  "decisions.title": "Decis\u00e3o",
  "decisions.untitled": "Escolha uma op\u00e7\u00e3o",
  "decisions.contextDefault": "Decis\u00e3o solicitada",
  "decisions.context.project": "Projeto",
  "decisions.prompt.homepageDirection": "Qual dire\u00e7\u00e3o devemos seguir para a homepage?",
  "decisions.option.directionA": "Dire\u00e7\u00e3o A",
  "decisions.option.directionB": "Dire\u00e7\u00e3o B",
  "decisions.optionUntitled": "Op\u00e7\u00e3o",
  "decisions.optionsLabel": "Op\u00e7\u00f5es dispon\u00edveis",
  "decisions.submit": "Registrar escolha",
  "decisions.submitting": "Registrando escolha\u2026",
  "decisions.success": "Sua escolha foi registrada.",
  "decisions.stale": "Esta decis\u00e3o foi atualizada. Revise a vers\u00e3o mais recente antes de responder.",
  "decisions.ownerUnavailable": "Esta decis\u00e3o pertence a outro sistema e n\u00e3o pode ser respondida por aqui agora.",
  "decisions.validation": "Selecione uma op\u00e7\u00e3o v\u00e1lida antes de continuar.",
  "decisions.error": "N\u00e3o foi poss\u00edvel registrar sua escolha agora.",
  "decisions.externalReadOnly": "Esta decis\u00e3o \u00e9 controlada pelo sistema respons\u00e1vel e est\u00e1 dispon\u00edvel somente para consulta aqui.",
  "decisions.readOnly": "Esta decis\u00e3o est\u00e1 dispon\u00edvel somente para consulta neste momento.",
  "decisions.selection": "Escolha registrada",
  "decisions.history": "Hist\u00f3rico",
  "decisions.status.OPEN": "Aguardando sua escolha",
  "decisions.status.DECIDED": "Decidida",
  "decisions.status.CANCELLED": "Cancelada",
  "decisions.status.SUPERSEDED": "Substitu\u00edda",
  "decisions.history.OPENED": "Decis\u00e3o aberta",
  "decisions.history.DECIDED": "Escolha registrada",
  "decisions.history.CANCELLED": "Decis\u00e3o cancelada",
  "decisions.history.SUPERSEDED": "Decis\u00e3o substitu\u00edda",
  "activity.decision.selected": "Sua escolha foi registrada",

  // Layout grammar (V1 UI refresh)
  "layout.breadcrumb": "Caminho da página",
  "support.noMessages": "Nenhuma mensagem neste chamado ainda.",
  "layout.filter": "Filtrar",
  "layout.filter.all": "Todos",
  "layout.filter.pending": "Pendentes",
  "layout.filter.inProgress": "Em andamento",
  "layout.filter.done": "Concluídos",
  "layout.context": "Informações relacionadas",
  "layout.noResults": "Nenhum resultado para este filtro.",
  "layout.shortcuts": "Atalhos",
  "layout.search": "Buscar por nome",
  "layout.details": "Detalhes",
  "layout.status": "Status",
  "layout.createdAt": "Criada em",
  "layout.completedAt": "Concluída em",
  "common.viewAll": "Ver tudo",
  "projects.estimate": "Previsão",
  "projects.deliverablesEmpty": "Nenhuma entrega publicada ainda.",
  "proposals.items": "Itens da proposta",
  "questionnaires.answers": "Suas respostas",
  "support.channels": "Outros canais",
  "home.pulse.label": "Resumo rápido",
  "home.pulse.actions": "ações pendentes",
  "home.pulse.inProgress": "projetos e serviços ativos",
  "home.pulse.openInvoices": "faturas em aberto",
  "home.pulse.overdue.one": "faturas em aberto · {count} vencida",
  "home.pulse.overdue.other": "faturas em aberto · {count} vencidas",
  "home.pulse.tickets": "chamados ativos",
  "home.pulse.waitingYou.one": "chamados ativos · {count} aguarda você",
  "home.pulse.waitingYou.other": "chamados ativos · {count} aguardam você",
  "publicHome.feature.projects": "Etapas, entregas e aprovações dos seus projetos",
  "publicHome.feature.billing": "Faturas e pagamentos com status em tempo real",
  "publicHome.feature.support": "Suporte com histórico completo de conversas",
} as const;

export const en = {
 "billing.invoice.download":"Download invoice PDF",
 "billing.receipt.ownerMissing":"The PDF shows the amounts and payment recorded in Cashier. The bank receipt is a separate document; request it from support when unavailable.",
"contracts.signer":"Recorded signer",
"contracts.validatedAt":"Validation recorded on",
"contracts.evidence.MANUAL_VALIDATION":"Manual validation recorded in Stargate",
"contracts.evidence.PROVIDER_RECORDED":"Signature provider recorded",
"contracts.evidence.NOT_AVAILABLE":"Signature evidence unavailable",
"contracts.firstPage":"First page",
"contracts.lastPage":"Last page",
"contracts.previousPage":"Previous page",
"contracts.nextPage":"Next page",
"contracts.pageOf":"Page {page} of {total}",
"contracts.previewError":"Could not load the contract. Refresh the page or contact support.",
"contracts.originalFile": "Original contract recorded in Stargate",
"contracts.openOriginal": "Open complete contract PDF",
"contracts.signedFileMissing":"Signature metadata is recorded, but the signed file and signature certificate have not been made available. Request the complete document from Cupcode.",

 "services.deliveryDate":"Recorded delivery date",
  "services.view": "View service",
  "billing.phase.INITIAL_50": "Initial payment · 50%",
  "billing.phase.CLOSING_50": "Closing payment · Remaining 50% on delivery",
  "support.openTicket": "Open ticket",
  "support.whatsapp": "Chat on WhatsApp",

  "approvals.reasonRequired": "Give a reason when requesting changes or rejecting",
  "approvals.deadline": "Deadline",
  "approvals.reject": "Reject",
  "approvals.status.REJECTED": "Rejected",
  "approvals.history.REJECTED": "Version rejected",
  "collaboration.files.title": "Files",
  "collaboration.files.add": "Upload file",
  "collaboration.files.allowed": "PDF, images or text, up to 10 MB",
  "collaboration.files.download": "Download",
  "collaboration.files.invalid": "Invalid file type or size",
  "collaboration.files.uploading": "Uploading file",
  "collaboration.files.scanPending": "File received, awaiting security checks",
  "collaboration.files.error": "Could not complete the file operation",
  "collaboration.files.refresh": "Refresh files",
  "collaboration.requests.title": "Requests",
  "collaboration.requests.subtitle": "Information and files requested by Cupcode",
  "collaboration.requests.empty": "No requests published for you",
  "collaboration.requests.view": "View request",
  "collaboration.requests.deadline": "Deadline",
  "collaboration.requests.response": "Your response",
  "collaboration.requests.authorize": "I confirm the displayed authorization",
  "collaboration.requests.submit": "Submit response",
  "collaboration.requests.submitting": "Submitting response",
  "collaboration.requests.submitted": "Response submitted for review",
  "collaboration.requests.stale": "The request changed. Refresh before responding",
  "collaboration.requests.error": "Could not submit the response",
  "collaboration.requests.readOnly": "View the information for this request",
  "collaboration.deliverables.title": "Deliverable",
  "collaboration.deliverables.published": "Published for you",
  "collaboration.deliverables.version": "Version",
  "collaboration.deliverables.publishedAt": "Published on",
  "decisions.listTitle": "Decisions",
  "decisions.subtitle": "Choices Cupcode needs from you.",
  "decisions.empty": "No decisions available.",
  "collaboration.deliverables.listTitle": "Deliverables",
  "collaboration.deliverables.subtitle": "Deliverables published for you.",
  "collaboration.deliverables.empty": "No deliverables published yet.",
  "help.title": "Help center",
  "help.subtitle": "Quick answers to the most common questions.",
  "help.empty": "No articles available right now.",
  "help.openCenter": "Open support center",
  "upgrade.badge": "Upgrade available",
  "upgrade.cta": "View upgrade",
  "upgrade.card.title": "{service}: move up to {target}",
  "upgrade.card.body": "Go from {current} to {target} for {difference} more.",
  "upgrade.perMonth": "/mo",
  "upgrade.perYear": "/yr",
  "upgrade.modal.title": "{service} upgrade",
  "upgrade.modal.description": "From {current} to {target}.",
  "upgrade.modal.current": "Current plan",
  "upgrade.modal.new": "New plan",
  "upgrade.modal.difference": "Difference",
  "upgrade.modal.note": "We send the request to the Cupcode team, who confirm the change with you. You are not charged now.",
  "upgrade.modal.noPermission": "Your access does not allow requesting upgrades. Please contact the Cupcode team.",
  "upgrade.modal.submit": "Request upgrade",
  "upgrade.modal.cancel": "Not now",
  "upgrade.sent": "Upgrade request sent.",
  "upgrade.error": "We could not send the request right now. Please try again.",
  "upgrade.request.subject": "{service} upgrade: {current} to {target}",
  "upgrade.request.text": "Hello! I would like to upgrade {service} from {current} to {target} ({price}, {difference} more). Could you help me with the next steps?",
  "navigation.ads": "Ads",
  "ads.title": "Ads",
  "ads.subtitle": "Performance of your paid traffic campaigns.",
  "ads.demo.badge": "Demo data",
  "ads.demo.note": "These numbers are illustrative. We will connect your company's ad account to show real data.",
  "ads.period.label": "Period",
  "ads.period.7": "7 days",
  "ads.period.30": "30 days",
  "ads.period.90": "90 days",
  "ads.kpis": "Period indicators",
  "ads.vsPrevious": "vs. previous period",
  "ads.unavailable": "We could not load the ads data right now.",
  "ads.metric.spend": "Spend",
  "ads.metric.impressions": "Impressions",
  "ads.metric.clicks": "Clicks",
  "ads.metric.conversions": "Conversions",
  "ads.metric.revenue": "Revenue",
  "ads.metric.ctr": "CTR",
  "ads.metric.cpc": "CPC",
  "ads.metric.cpa": "CPA",
  "ads.metric.roas": "ROAS",
  "ads.chart.title": "Daily trend",
  "ads.chart.metric": "Chart metric",
  "ads.chart.summary": "{metric} per day, from {from} to {to}",
  "ads.campaigns.title": "Campaigns",
  "ads.campaigns.name": "Campaign",
  "ads.campaigns.platform": "Platform",
  "ads.platform.GOOGLE_ADS": "Google Ads",
  "ads.platform.META_ADS": "Meta Ads",
  "ads.status.ACTIVE": "Active",
  "ads.status.PAUSED": "Paused",
  "profile.title": "Complete your company profile",
  "profile.description": "It takes under a minute and helps Cupcode serve {company} better.",
  "profile.employees.label": "How many employees does the company have?",
  "profile.employees.placeholder": "Select",
  "profile.employees.1": "Just me",
  "profile.employees.2-10": "2 to 10",
  "profile.employees.11-50": "11 to 50",
  "profile.employees.51-200": "51 to 200",
  "profile.employees.201-500": "201 to 500",
  "profile.employees.500+": "More than 500",
  "profile.segment.label": "Industry",
  "profile.segment.placeholder": "E.g. women's fashion, dental clinic",
  "profile.website.label": "Website (optional)",
  "profile.website.placeholder": "company.com",
  "profile.about.label": "What the company does, in a few words (optional)",
  "profile.save": "Save profile",
  "profile.later": "Remind me later",
  "profile.saved": "Profile saved. Thank you!",
  "profile.error.validation": "Check the fields and try again.",
  "profile.error.forbidden": "Your access does not allow editing the profile.",
  "profile.error.unavailable": "We could not save right now. Please try again.",
  "agenda.title": "Agenda",
  "agenda.subtitle": "Your upcoming meetings and the times available to book.",
  "agenda.upcoming.title": "Upcoming meetings",
  "agenda.upcoming.empty": "You have no scheduled meetings.",
  "agenda.duration": "{minutes} min",
  "agenda.status.SCHEDULED": "Scheduled",
  "agenda.status.CONFIRMED": "Confirmed",
  "agenda.cancel": "Cancel",
  "agenda.cancel.title": "Cancel this meeting?",
  "agenda.cancel.description": "The meeting on {when} will be cancelled and the time becomes available again.",
  "agenda.cancel.confirm": "Cancel meeting",
  "agenda.cancel.keep": "Keep",
  "agenda.cancelled": "Meeting cancelled.",
  "agenda.book.title": "Book a meeting",
  "agenda.book.pickDay": "Pick a day with available times.",
  "agenda.book.pickTime": "Available times on {day}",
  "agenda.book.noSlots": "No times available this month.",
  "agenda.book.topic": "Topic (optional)",
  "agenda.book.confirm": "Confirm booking",
  "agenda.book.review.title": "Confirm meeting?",
  "agenda.book.review.back": "Back",
  "errors.noNaveAccess.title": "No access to Nave",
  "errors.noNaveAccess.body": "Your Cupcode account is active but does not have access to Nave yet. Ask your company administrator or the Cupcode team for access, or sign in with another account.",
  "navigation.adsDemo": "Ads (demo)",
  "agenda.book.select": "Select",
  "agenda.book.chosen": "Selected",
  "agenda.join": "Join the video call",
  "agenda.booked.email": "We e-mailed the confirmation with the video call link and the calendar invite.",
  "support.sender.you": "You",
  "support.conversation.waitingCupcode": "The Cupcode team will reply here. You also get a notice when the reply arrives.",
  "support.conversation.waitingClient": "The team replied and is waiting for you. Reply below to continue.",
  "support.conversation.closed": "This ticket is closed. If you need to, reply below to reopen the conversation.",
  "support.reply.placeholder": "Write your reply\u2026",
  "support.reply.hint": "Ctrl + Enter to send",
  "upgrade.progress.label": "Upgrade steps",
  "upgrade.progress.sign": "Sign the contract",
  "upgrade.progress.signed": "Contract signed",
  "upgrade.progress.signDetail": "We sent the contract to {email}. Open the e-mail, review the terms and sign.",
  "upgrade.progress.signSendFailed": "We could not send the contract e-mail right now. Please try again.",
  "upgrade.progress.send": "Send contract by e-mail",
  "upgrade.progress.resend": "Resend e-mail",
  "upgrade.progress.pay": "Pay {amount}",
  "upgrade.progress.paid": "Payment confirmed",
  "upgrade.progress.payDetail": "Pro-rata difference of the upgrade. As soon as the payment is confirmed, the new plan takes effect.",
  "upgrade.progress.payNow": "Pay {amount}",
  "upgrade.progress.activate": "{target} plan active",
  "upgrade.progress.active": "{target} plan active",
  "upgrade.progress.activeDetail": "Our team has been notified and will set everything up with you.",
  "upgrade.progress.checkInbox": "Can't find the e-mail? Check your spam folder too.",
  "upgrade.progress.sent": "Contract sent by e-mail.",
  "upgrade.progress.close": "Close",
  "upgrade.status.badge": "Upgrade in progress",
  "upgrade.status.badgeActive": "Upgrade active",
  "upgrade.status.sign": "Sign the {target} contract",
  "upgrade.status.signBody": "We e-mailed the contract. You only need to sign.",
  "upgrade.status.pay": "Pay {amount} to activate {target}",
  "upgrade.status.payBody": "Contract signed. The new plan starts as soon as the payment is confirmed.",
  "upgrade.status.active": "{target} active",
  "upgrade.status.activeBody": "Payment confirmed. Our team will set everything up with you.",
  "upgrade.status.ctaSign": "See steps",
  "upgrade.status.ctaPay": "Pay now",
  "upgrade.status.ctaActive": "See details",
  "upgrade.self.cta": "Get the upgrade",
  "upgrade.self.step1": "You confirm and the contract goes to the legal representative's e-mail ({email}).",
  "upgrade.self.step2": "It is signed digitally, with code verification.",
  "upgrade.self.step3": "You pay {amount}, the pro-rata difference for the {remaining} days left in the cycle.",
  "upgrade.self.step4": "Your plan changes to {target} and our team sets everything up with you.",
  "upgrade.self.error.changed": "The amount changed. Check the new amount and confirm again.",
  "upgrade.self.error.inProgress": "There is already an upgrade in progress for this service.",
  "upgrade.self.error.noRepresentative": "We could not find the company's legal representative. Talk to the team to complete the upgrade.",
  "upgrade.self.error.contract": "We could not prepare the contract right now. Try again or request it through support.",
  "upgrade.quote.now": "To switch now",
  "upgrade.quote.nowDetail": "Pro-rata difference: {remaining} of {total} days left in the current cycle",
  "upgrade.quote.from": "From {date}",
  "upgrade.quote.fromDetail": "{target} price every cycle",
  "upgrade.modal.step3Quote": "After confirmation you pay {amount} and the new plan takes effect. Nothing is charged now.",
  "upgrade.request.quote": "Pro-rata amount shown in the portal: {amount} ({remaining} of {total} days of the current cycle); full price from {date}.",
  "upgrade.includes.keptCount": "See the {count} items you keep",
  "upgrade.includes.titleCompare": "What you get with {target}",
  "upgrade.includes.titleAll": "What {target} includes",
  "upgrade.includes.new": "New",
  "questionnaires.draftSaved": "Draft saved.",
  "questionnaires.completed": "Questionnaire completed. Thank you!",
  "approvals.reasonMissing": "Write the reason in the comment before requesting changes or rejecting.",
  "profile.cta": "Complete profile",
  "upgrade.modal.yourPlan": "Your plan",
  "upgrade.modal.how": "How it works",
  "upgrade.modal.step1": "You send the request here.",
  "upgrade.modal.step2": "The Cupcode team confirms the details with you.",
  "upgrade.modal.step3": "Your plan only changes after you confirm. Nothing is charged now.",
  "home.attention.cta.review": "Review",
  "home.attention.cta.choose": "Choose",
  "home.attention.cta.respond": "Respond",
  "home.attention.cta.open": "Open",
  "collaboration.files.none": "No files attached.",
  "collaboration.files.choose": "Choose file",
  "notifications.subtitle": "Updates about payments and your account.",
  "notifications.refresh": "Refresh",
  "notifications.unreadCount.one": "{count} unread",
  "notifications.unreadCount.other": "{count} unread",
  "agenda.legend.title": "Calendar legend",
  "agenda.legend.available": "Available",
  "agenda.legend.holiday": "Holiday",
  "agenda.legend.selected": "Selected",
  "agenda.holiday.newYear": "New Year's Day",
  "agenda.holiday.carnival": "Carnival",
  "agenda.holiday.goodFriday": "Good Friday",
  "agenda.holiday.tiradentes": "Tiradentes Day",
  "agenda.holiday.labour": "Labour Day",
  "agenda.holiday.corpusChristi": "Corpus Christi",
  "agenda.holiday.independence": "Independence Day",
  "agenda.holiday.ourLady": "Our Lady of Aparecida",
  "agenda.holiday.allSouls": "All Souls' Day",
  "agenda.holiday.republic": "Republic Proclamation Day",
  "agenda.holiday.blackAwareness": "Black Awareness Day",
  "agenda.holiday.christmas": "Christmas Day",
  "agenda.book.selected": "{day} at {time} \u00b7 {minutes} min",
  "agenda.book.timezone": "Times shown in {zone}.",
  "agenda.book.notice": "Book at least {hours} h ahead.",
  "agenda.booked": "Meeting booked: {when}.",
  "agenda.book.noPermission": "Your access does not allow booking meetings. Please contact the Cupcode team.",
  "agenda.error.taken": "That time was just taken. Please choose another.",
  "agenda.error.validation": "Check the details and try again.",
  "agenda.error.forbidden": "Your access does not allow this action.",
  "agenda.error.unavailable": "We could not complete this right now. Please try again.",
  "agenda.unavailable": "We could not load the agenda right now.",
  "calendar.previous": "Previous month",
  "calendar.next": "Next month",
  "agenda.admin.title": "Team availability",
  "agenda.admin.description": "Set the days and times customers can book meetings.",
  "agenda.admin.weekday": "Weekday",
  "agenda.admin.start": "Start",
  "agenda.admin.end": "End",
  "agenda.admin.slot": "Length",
  "agenda.admin.active": "Active",
  "agenda.admin.slotMinutes": "{minutes} min",
  "agenda.admin.addRule": "Add time window",
  "agenda.admin.removeRule": "Remove time window",
  "agenda.admin.empty": "No times set. Customers cannot book.",
  "agenda.admin.blocks": "Blocked dates",
  "agenda.admin.blockDate": "Date",
  "agenda.admin.blockReason": "Reason (optional)",
  "agenda.admin.addBlock": "Block date",
  "agenda.admin.removeBlock": "Remove block",
  "agenda.admin.save": "Save availability",
  "agenda.admin.saved": "Availability saved.",
  "navigation.group.work": "Collaboration",
  "navigation.group.commercial": "Billing & contracts",
  "navigation.group.service": "Support & help",
  "collaboration.requests.status.WAITING_CLIENT": "Awaiting your response",
  "collaboration.requests.status.SUBMITTED": "Submitted for review",
  "collaboration.requests.status.UNDER_REVIEW": "Under review",
  "collaboration.requests.status.COMPLETED": "Completed",
  "collaboration.requests.status.CANCELLED": "Cancelled",
  "collaboration.requests.status.EXPIRED": "Expired",
  "collaboration.requests.status.SUPERSEDED": "Superseded",

  "documents.download": "Download document",
  "documents.downloadError": "Could not download the document",
  "documents.version": "Version",
  "questionnaires.choose": "Choose an option",
  "questionnaires.submit": "Complete questionnaire",
  "questionnaires.versionConflict": "The version changed. Refresh the questionnaire before responding",
  "questionnaires.required": "Complete the required fields",
  "questionnaires.submitError": "Could not save your answers",
  "questionnaires.save": "Save draft",

  "contracts.status.PENDING_SIGNATURE": "Awaiting signature",
  "contracts.status.SUPERSEDED": "Superseded",
  "contracts.status.CANCELLED": "Cancelled",

  "billing.service": "Contracted service",
  "billing.plan": "Plan",
  "billing.contract": "Contract",
  "billing.competence": "Billing month",
  "billing.period.title": "Billing period",
  "billing.subtotal": "Subtotal",
  "billing.additions": "Additions",
  "billing.amountPaid": "Amount paid",
  "billing.payment.title": "Payment",
  "billing.payment.explanation": "Complete payment in the secure Cashier checkout. When you return, check the updated status.",
  "billing.payment.cashier": "Pay with Cashier",
  "billing.payment.unavailable": "Payment for this invoice is temporarily unavailable. Contact support.",
  "billing.payment.refresh": "Refresh status",
  "billing.history.title": "Confirmed payments",
  "billing.history.empty": "No confirmed payment for this invoice.",
  "billing.method.PIX": "Pix",
  "billing.method.CARD": "Card",
  "billing.method.BOLETO": "Boleto",

  "platform.admin": "Platform administration",
  "platform.search": "Search organization",
  "platform.viewing": "Viewing: {organization}",
  "platform.return": "Exit customer view",
  "organization.switchFailed": "Could not switch organization. Try again.",

  "app.name": "Nave",
  "app.tagline": "Your Cupcode space",
  "navigation.home": "Home",
  "navigation.foundation": "Foundation V0.1",
  "organization.label": "Organization",
  "organization.switch": "Switch organization",
  "organization.single": "Active organization",
  "language.label": "Language",
  "language.ptBR": "Português",
  "language.en": "English",
  "language.es": "Español",
  "theme.label": "Theme",
  "theme.light": "Light",
  "theme.dark": "Dark",
  "scenario.label": "Development scenario",
  "user.menu": "Account menu",
  "user.emailUnavailable": "Email unavailable",
  "production.unavailable.title": "Nave is unavailable in this environment",
  "production.unavailable.body": "The required production integrations are not configured yet. Demo data will not be used as a fallback.",
  "production.profileUnavailable.title": "Your session was recognized",
  "production.profileUnavailable.body": "Your organization and customer data could not be loaded safely. No demo data will be shown.",
  "publicHome.title": "Welcome to your Cupcode Spaceship",
  "publicHome.description": "Follow your projects, services, documents, billing, and support in one experience.",
  "publicHome.signIn": "Sign in with Cupcode",
  "publicHome.loginUnavailable": "Sign-in could not be started. Please try again shortly.",
  "publicHome.returnNotice": "After signing in, you will return to the page you requested.",
  "production.organization.choose": "Choose an organization",
  "production.organization.none": "No active organization is linked to your account.",
  "production.dashboard.sections": "Your organization data",
  "production.dashboard.services": "Services",
  "production.dashboard.projects": "Projects",
  "production.dashboard.integrationUnavailable": "Real data for this area could not be loaded yet.",
  "production.dashboard.loading": "Loading your organization data…",
  "production.dashboard.projectsEmpty": "No project published for you is available for the selected customer.",
  "production.project.back": "Back to Projects & Services",
  "services.status.PAUSED": "Paused",
  "services.status.COMPLETED": "Completed",
  "services.status.ENDED": "Ended",
  "services.status.UNAVAILABLE": "Status unavailable",
  "account.authRequired.title": "Sign in to continue",
  "account.authRequired.body": "Your session is not authenticated. Sign in through Cupcode Accounts to continue in Nave.",
  "account.authRequired.afterLogoutBody": "Your local Nave session has ended. Sign in again to continue.",
  "account.sessionExpired.title": "Your session expired",
  "account.sessionExpired.body": "For security, you need to sign in again to continue.",
  "account.loginCancelled.title": "Sign-in cancelled",
  "account.loginCancelled.body": "Sign-in was cancelled. You can try again whenever you are ready.",
  "account.actions.signIn": "Sign in",
  "account.actions.signOut": "Sign out",
  "account.actions.signInAgain": "Sign in again",
  "account.actions.restart": "Restart sign-in",
  "account.authAction.notConnected": "The Cupcode Accounts connection will be enabled in a later integration stage.",
  "account.callback.title": "Validating your sign-in",
  "account.callback.body": "We are completing verification before opening your Nave experience.",
  "account.callback.loading": "Validating sign-in",
  "organization.selection.title": "Choose an organization",
  "organization.selection.description": "Select an available organization to continue.",
  "organization.selection.label": "Available organization",
  "organization.selection.placeholder": "Select an organization",
  "organization.selection.continue": "Continue",
  "organization.unavailable.title": "Organization unavailable",
  "organization.unavailable.body": "This organization cannot be made available safely right now.",
  "errors.accountsUnavailable.title": "Account service temporarily unavailable",
  "errors.accountsUnavailable.body": "We could not confirm your account right now. Try again later.",
  "errors.membershipRequired.title": "Customer access not found",
  "errors.membershipRequired.body": "Your account is authenticated, but there is no eligible customer access available in Nave.",
  "errors.invalidEntryContext.title": "This sign-in could not be validated",
  "errors.invalidEntryContext.body": "The received entry is invalid or cannot be used safely. Start the flow again.",
  "errors.expiredEntryContext.title": "This entry expired",
  "errors.expiredEntryContext.body": "The entry expired and needs to be started again.",
  "errors.resourceConflict.title": "This action is no longer available",
  "errors.resourceConflict.body": "This item changed state. Refresh the experience before trying again.",
  "home.health.READY": "Up to date",
  "home.health.PARTIAL": "Partial",
  "home.health.STALE": "May be outdated",
  "home.health.UNAVAILABLE": "Unavailable",
  "priority.LOW": "Low",
  "priority.NORMAL": "Normal",
  "priority.HIGH": "High",
  "priority.CRITICAL": "Critical",
  "services.status.ACTIVE": "Active",
  "products.name.telescup": "Telescup",
  "products.name.aidar-seo": "AiDAR SEO",
  "products.name.aidar-copy": "AiDAR Copy",
  "products.name.cupcode-host": "Cupcode Host",
  "products.title": "Products",
  "products.empty": "No contracted digital product is available for the selected customer.",
  "products.plan": "Plan / reference",
  "products.limits": "Contracted limits",
  "products.open": "Open product",
  "products.access.ALLOWED": "Access is authorized for this user.",
  "products.access.DENIED": "You do not have access to this application.",
  "products.access.UNAVAILABLE": "Your access to this application could not be confirmed right now.",
  "products.status.ACTIVE": "Active",
  "products.status.INACTIVE": "Inactive",
  "products.status.SUSPENDED": "Suspended",
  "activity.generic": "Update available",
  "home.greeting": "Overview",
  "home.subtitle": "What needs your attention and what is happening now.",
  "home.attention.title": "Needs you",
  "home.attention.empty": "Nothing needs your action right now.",
  "home.progress.title": "In progress",
  "home.progress.empty": "No active project or service.",
  "home.billing.title": "Billing",
  "home.billing.empty": "No relevant billing item right now.",
  "home.usage.title": "Products and usage",
  "home.usage.empty": "No relevant usage alert.",
  "home.support.title": "Support",
  "home.support.empty": "No relevant active support case.",
  "home.activity.title": "Recent activity",
  "home.activity.empty": "No recent activity.",
  "state.loading": "Loading…",
  "state.stale": "Data may be out of date.",
  "state.unavailable": "This section is temporarily unavailable.",
  "state.partial": "Some information is temporarily unavailable.",
  "section.state.READY": "Available",
  "section.state.STALE": "Stale",
  "section.state.EMPTY": "Empty",
  "section.state.UNAVAILABLE": "Unavailable",
  "errors.generic.title": "This area could not be loaded",
  "errors.generic.body": "Try again or keep using the other available areas.",
  "errors.forbidden.title": "Access unavailable",
  "errors.forbidden.body": "This content is not available with your current access.",
  "errors.unavailable.title": "Service temporarily unavailable",
  "errors.unavailable.body": "A required dependency did not respond. Other areas remain available when possible.",
  "errors.notFound.title": "Page not found",
  "errors.notFound.body": "The address may be incorrect or the page does not exist in this version yet.",
  "errors.notFound.back": "Back to home",
  "billing.nextInvoice": "Next invoice",
  "billing.overdue": "Overdue",
  "billing.open": "Open",
  "billing.due": "Due",
  "navigation.billing": "Billing",
  "navigation.support": "Support",
  "billing.page.title": "Billing",
  "billing.page.subtitle": "Review your invoices and the amounts provided by Cupcode's financial system.",
  "billing.summary.title": "Financial status",
  "billing.summary.open": "Open",
  "billing.summary.overdue": "Overdue",
  "client.label": "Customer",
  "client.search": "Search customers",
  "client.choose": "Select customer",
  "client.selectionRequired": "Select a customer above to view their information.",
  "client.test": "Test customer",
  "billing.noFinancialAccount": "Select a customer to view billing. Other areas remain available.",
  "billing.summary.clear": "Everything is up to date with your billing right now.",
  "billing.invoices.title": "Invoices",
  "billing.invoices.empty": "No invoices are available for the selected customer.",
  "billing.invoices.loadMore": "Load more invoices",
  "billing.invoices.loadingMore": "Loading more invoices…",
  "billing.invoices.loadMoreError": "More invoices could not be loaded right now.",
  "billing.invoice.label": "Invoice",
  "billing.invoice.view": "View invoice",
  "billing.invoice.detailTitle": "Invoice {id}",
  "billing.invoice.summary": "Invoice summary",
  "billing.invoice.status.open": "Open",
  "billing.invoice.status.overdue": "Overdue",
  "billing.invoice.status.paid": "Paid",
  "billing.invoice.status.cancelled": "Cancelled",
  "billing.payment.status.pending": "Pending",
  "billing.payment.status.processing": "Processing",
  "billing.payment.status.paid": "Paid",
  "billing.payment.status.failed": "Failed",
  "billing.payment.status.cancelled": "Cancelled",
  "billing.payment.status.refunded": "Refunded",
  "billing.total": "Total amount",
  "billing.balance": "Balance",
  "billing.paymentStatus": "Payment status",
  "billing.issuedAt": "Issued on",
  "billing.paidAt": "Paid on",
  "billing.items.title": "Invoice items",
  "billing.period.unspecified": "Period not provided",
  "billing.errors.forbidden.title": "Billing is unavailable for this access",
  "billing.errors.forbidden.body": "Your current access does not allow you to view this organization's financial information.",
  "billing.errors.notFound.title": "Invoice not found",
  "billing.errors.notFound.body": "This invoice is not available for the selected customer or your access scope.",
  "billing.errors.unavailable.title": "Billing is temporarily unavailable",
  "billing.errors.unavailable.body": "The financial system could not be reached right now. Other Nave areas remain available.",
  "billing.errors.generic.title": "Billing could not be loaded",
  "billing.errors.generic.body": "An unexpected error occurred while loading this area.",
  "projects.status.IN_PROGRESS": "In progress",
  "projects.status.WAITING_CLIENT": "Waiting for you",
  "projects.status.COMPLETED": "Completed",
  "projects.stage.development": "Development",
  "usage.threshold.SOFT_LIMIT": "Near limit",
  "usage.threshold.HARD_LIMIT": "Limit reached",
  "usage.title": "Product usage",
  "usage.empty": "No usage metrics are available for this product.",
  "usage.unavailable": "Usage data for this product is temporarily unavailable.",
  "usage.used": "Used",
  "usage.included": "Included",
  "usage.remaining": "Remaining",
  "usage.softLimit": "Attention limit",
  "usage.hardLimit": "Hard limit",
  "usage.overage": "Overage",
  "usage.periodStart": "Period starts",
  "usage.periodEnd": "Period ends",
  "usage.resetAt": "Period resets",
  "usage.updatedAt": "Updated at",
  "usage.metric.storage": "Storage",
  "usage.metric.analyses": "Analyses",
  "usage.unit.analysis.one": "analysis",
  "usage.unit.analysis.other": "analyses",
  "usage.limit.SOFT_LIMIT": "Near limit",
  "usage.limit.HARD_LIMIT": "Limit reached",
  "attention.action.project": "Project awaiting your action",
  "attention.action.support": "Reply to support",
  "activity.invoicePaid": "Payment confirmed",
  "usage.assets": "Assets",
  "usage.storage": "Storage",
  "usage.unit.assets.one":"asset",
  "usage.unit.assets.other":"assets",
  "usage.unit.credits.one":"credit",
  "usage.unit.credits.other":"credits",
  "usage.monitoredUrls": "Monitored URLs",
  "usage.aiCredits": "AI credits",
  "support.reply.title": "Reply to ticket",
  "support.create.title": "New ticket",
  "support.create.noServices": "No services are available for opening a ticket for this customer.",
  "support.create.service": "Service",
  "support.create.subject": "Subject",
  "support.message": "Message",
  "support.sending": "Sending…",
  "support.reply.send": "Send reply",
  "support.create.send": "Open ticket",
  "support.validation": "Check the subject and message before sending.",
  "support.conflict": "This attempt was already sent with different content. Refresh the ticket before trying again.",
  "notifications.title":"Notifications",
  "notifications.unavailable.title":"Notifications temporarily unavailable",
  "notifications.unavailable.body":"Your notifications could not be loaded right now. Other areas remain available.",
  "notifications.empty":"You have no available notifications for this customer.",
  "notifications.read":"Read",
  "notifications.unread":"Unread",
  "notifications.markRead":"Mark as read",
  "notifications.partial":"Showing recent payment notifications.",
  "support.attachments":"Attachments",
  "support.download":"Download file",
  "support.chooseFile":"Choose file",
  "support.upload":"Upload file",
  "support.attachmentError":"The file is not available now. Check its type and size or wait for the security scan.",
  "support.attachment.pending":"Upload pending",
  "support.attachment.stored":"File received",
  "support.attachment.clean":"Scan completed",
  "support.attachment.blocked":"File blocked",
  "support.attachment.error":"Scan failed",
  "support.help":"Help center",
  "support.helpEmpty":"There are no published articles available now.",
  "support.readArticle":"Read article",
  "support.finalize":"Confirm resolution",
  "support.reopen":"Reopen ticket",
  "support.actionError":"The ticket could not be updated. Refresh to confirm its current state.",
  "support.conversation":"Conversation",
  "support.sender.CLIENT":"Customer",
  "support.sender.CUPCODE":"Cupcode",
  "support.moreMessages":"The 100 most recent messages are available in this conversation.",
  "support.page.title": "Support",
  "support.page.subtitle": "Track the tickets available to the selected customer and see who is waiting for the next update.",
  "support.summary.title": "Recent support",
  "support.tickets.title": "Tickets",
  "support.tickets.empty": "No tickets are available for the selected customer.",
  "support.tickets.moreAvailable": "There are more tickets beyond those shown on this page.",
  "support.tickets.loadMore": "Load more tickets",
  "support.tickets.loadingMore": "Loading more tickets…",
  "support.tickets.loadMoreError": "More tickets could not be loaded right now.",
  "support.ticket.label": "Ticket",
  "support.ticket.view": "View ticket",
  "support.ticket.summary": "Ticket summary",
  "support.lastActivity": "Last activity",
  "support.awaiting": "Waiting for",
  "support.awaiting.CUPCODE": "Cupcode",
  "support.awaiting.CLIENT": "You",
  "support.awaiting.NONE": "No one",
  "support.unread": "Unread",
  "support.serviceRef": "Related service",
  "support.errors.forbidden.title": "Support unavailable for this access",
  "support.errors.forbidden.body": "Your current access does not allow you to view the selected customer's tickets.",
  "support.errors.notFound.title": "Ticket not found",
  "support.errors.notFound.body": "This ticket is not available to the selected customer or access scope.",
  "support.errors.unavailable.title": "Support temporarily unavailable",
  "support.errors.unavailable.body": "The support system could not be reached right now. Other Nave areas remain available.",
  "support.errors.generic.title": "Support could not be loaded",
  "support.errors.generic.body": "An unexpected error occurred while loading this area.",
  "support.status.WAITING_CUPCODE": "Waiting for Cupcode",
  "support.status.WAITING_CLIENT": "Waiting for you",
  "support.status.IN_PROGRESS": "In progress",
  "support.status.RESOLVED": "Resolved",
  "support.status.CLOSED": "Closed",
  "attention.action.approval": "Approval pending",
  "attention.action.clientRequest": "Information requested",
  "attention.action.payInvoice": "Overdue invoice",
  "activity.project.stageChanged": "The project moved to a new stage",
  "common.updatedAt": "Updated",
  "common.items": "items",
  "common.open": "Open",
  "common.action": "Action required",
  "common.attention": "Attention",
  "common.information": "Information",
  "navigation.projectsServices": "Projects & Services",
  "navigation.documents": "Documents",
  "projectsServices.title": "Projects & Services",
  "projectsServices.subtitle": "Track your projects and active services in one place.",
  "projects.title": "Projects",
  "projects.empty": "You have no projects in progress right now.",
  "projects.view": "View project",
  "projects.progress": "Progress",
  "projects.currentStage": "Current stage",
  "projects.nextStage": "Next stage",
  "projects.nextMilestone": "Next milestone",
  "projects.committedDate": "Committed date",
  "projects.requests": "Requests",
  "projects.requestsCount.one": "{count} related request.",
  "projects.requestsCount.other": "{count} related requests.",
  "projects.approvals": "Approvals",
  "projects.approvalsCount.one": "{count} related approval.",
  "projects.approvalsCount.other": "{count} related approvals.",
  "projects.activity": "Recent activity",
  "services.title": "Services",
  "services.empty": "No services are available for the selected customer.",
  "documents.title": "Documents",
  "documents.subtitle": "Contracts and proposals available to the selected customer.",
  "documents.reference": "Related document",
  "contracts.title": "Contracts",
  "contracts.untitled": "Contract",
  "contracts.empty": "No contracts available.",
  "contracts.view": "View contract",
  "contracts.signedAt": "Signed on",
  "contracts.startsAt": "Starts",
  "contracts.endsAt": "Ends",
  "proposals.title": "Proposals",
  "proposals.empty": "No proposals available.",
  "proposals.view": "View proposal",
  "proposals.createdAt": "Created on",
  "proposals.expiresAt": "Expires",
  "questionnaires.title": "Questionnaires",
  "questionnaires.subtitle": "Review questionnaires available from requests and authorized links.",
  "questionnaires.empty": "No questionnaires available.",
  "questionnaires.dueAt": "Due",
  "questionnaires.review": "Review",
  "questionnaires.progress": "Progress",
  "questionnaires.respondDeferred": "This questionnaire may require your response, but real editing remains in the responsible system.",
  "questionnaires.readOnly": "This questionnaire is available for review only.",
  "common.back": "Back",
  "common.retry": "Try again",
  "status.unknown": "Status available",
  "projects.status.NOT_STARTED": "Not started",
  "projects.status.WAITING_CUPCODE": "Waiting for Cupcode",
  "projects.status.UNDER_REVIEW": "Under review",
  "projects.status.SCHEDULED": "Scheduled",
  "projects.status.CANCELLED": "Cancelled",
  "contracts.status.ACTIVE": "Active",
  "contracts.status.SIGNED": "Signed",
  "contracts.status.EXPIRED": "Ended",
  "proposals.status.OPEN": "Open",
  "proposals.status.ACCEPTED": "Accepted",
  "proposals.status.EXPIRED": "Expired",
  "questionnaires.status.OPEN": "Open",
  "questionnaires.status.IN_PROGRESS": "In progress",
  "questionnaires.status.COMPLETED": "Completed",
  "approvals.eyebrow": "Collaboration",
  "approvals.title": "Approvals",
  "approvals.subtitle": "Review submitted versions and record your decision when an action is available.",
  "approvals.empty": "No approvals are available for the selected customer.",
  "approvals.view": "View approval",
  "approvals.untitled": "Approval",
  "approvals.version": "Version {version}",
  "approvals.versionLabel": "Version",
  "approvals.currentVersion": "Current version",
  "approvals.requestedAt": "Requested on",
  "approvals.completedAt": "Completed on",
  "approvals.artifactVersion": "Artifact version",
  "approvals.actionsLabel": "Approval actions",
  "approvals.actionVersionNotice": "Your decision will be recorded for version {version}.",
  "approvals.commentOptional": "Optional comment",
  "approvals.approve": "Approve this version",
  "approvals.requestChanges": "Request changes",
  "approvals.submitting": "Recording your decision…",
  "approvals.success": "Decision recorded successfully.",
  "approvals.stale": "This approval changed since you opened it. Refresh before responding.",
  "approvals.ownerUnavailable": "This approval belongs to another system and cannot be answered here right now.",
  "approvals.actionError": "Your decision could not be recorded right now.",
  "approvals.readOnly": "This approval is read-only right now.",
  "approvals.externalOwnerReadOnly": "This approval is controlled by its owning system and is available here as read-only.",
  "approvals.history": "History",
  "approvals.evidence": "Decision evidence",
  "approvals.history.VERSION_SUBMITTED": "Version submitted",
  "approvals.history.APPROVED": "Version approved",
  "approvals.history.CHANGES_REQUESTED": "Changes requested",
  "approvals.history.SUPERSEDED": "Approval superseded",
  "approvals.history.CANCELLED": "Approval cancelled",
  "approvals.status.READY": "Ready to send",
  "approvals.status.WAITING_CLIENT": "Waiting for you",
  "approvals.status.APPROVED": "Approved",
  "approvals.status.CHANGES_REQUESTED": "Changes requested",
  "approvals.status.SUPERSEDED": "Superseded",
  "approvals.status.CANCELLED": "Cancelled",
  "approvals.subject.homepage": "Website homepage",
  "activity.approval.approved": "You approved a version",
  "activity.approval.changesRequested": "You requested changes to a version",
  "attention.action.decision": "A decision needs your attention",
  "requests.decision.title": "Choice needed",
  "requests.decision.description": "Review the options and record your choice.",
  "feedback.title": "Feedback",
  "feedback.subtitle": "Discuss this context without changing the formal decision.",
  "feedback.empty": "There are no comments visible to you yet.",
  "feedback.commentLabel": "Your comment",
  "feedback.submit": "Send comment",
  "feedback.submitting": "Sending comment\u2026",
  "feedback.success": "Comment sent.",
  "feedback.unavailable": "We could not load this feedback right now.",
  "feedback.ownerUnavailable": "This feedback belongs to another system and cannot be submitted here right now.",
  "feedback.closed": "This conversation no longer accepts comments.",
  "feedback.validation": "Write a comment before sending.",
  "feedback.error": "Your comment could not be sent right now.",
  "feedback.externalReadOnly": "This feedback is controlled by its owning system and is available here as read-only.",
  "feedback.readOnly": "This feedback is read-only right now.",
  "feedback.status.OPEN": "Open",
  "feedback.status.RESOLVED": "Resolved",
  "feedback.status.CANCELLED": "Cancelled",
  "feedback.author.YOU": "You",
  "feedback.author.CUSTOMER": "Customer",
  "feedback.author.CUPCODE": "Cupcode",
  "decisions.eyebrow": "Collaboration",
  "decisions.title": "Decision",
  "decisions.untitled": "Choose an option",
  "decisions.contextDefault": "Requested decision",
  "decisions.context.project": "Project",
  "decisions.prompt.homepageDirection": "Which direction should we take for the homepage?",
  "decisions.option.directionA": "Direction A",
  "decisions.option.directionB": "Direction B",
  "decisions.optionUntitled": "Option",
  "decisions.optionsLabel": "Available options",
  "decisions.submit": "Record choice",
  "decisions.submitting": "Recording choice\u2026",
  "decisions.success": "Your choice was recorded.",
  "decisions.stale": "This decision was updated. Review the latest version before responding.",
  "decisions.ownerUnavailable": "This decision belongs to another system and cannot be answered here right now.",
  "decisions.validation": "Select a valid option before continuing.",
  "decisions.error": "Your choice could not be recorded right now.",
  "decisions.externalReadOnly": "This decision is controlled by its owning system and is available here as read-only.",
  "decisions.readOnly": "This decision is read-only right now.",
  "decisions.selection": "Recorded choice",
  "decisions.history": "History",
  "decisions.status.OPEN": "Waiting for your choice",
  "decisions.status.DECIDED": "Decided",
  "decisions.status.CANCELLED": "Cancelled",
  "decisions.status.SUPERSEDED": "Superseded",
  "decisions.history.OPENED": "Decision opened",
  "decisions.history.DECIDED": "Choice recorded",
  "decisions.history.CANCELLED": "Decision cancelled",
  "decisions.history.SUPERSEDED": "Decision superseded",
  "activity.decision.selected": "Your choice was recorded",

  // Layout grammar (V1 UI refresh)
  "layout.breadcrumb": "Breadcrumb",
  "support.noMessages": "No messages in this ticket yet.",
  "layout.filter": "Filter",
  "layout.filter.all": "All",
  "layout.filter.pending": "Pending",
  "layout.filter.inProgress": "In progress",
  "layout.filter.done": "Done",
  "layout.context": "Related information",
  "layout.noResults": "No results for this filter.",
  "layout.shortcuts": "Shortcuts",
  "layout.search": "Search by name",
  "layout.details": "Details",
  "layout.status": "Status",
  "layout.createdAt": "Created on",
  "layout.completedAt": "Completed on",
  "common.viewAll": "View all",
  "projects.estimate": "Estimate",
  "projects.deliverablesEmpty": "No deliverables published yet.",
  "proposals.items": "Proposal items",
  "questionnaires.answers": "Your answers",
  "support.channels": "Other channels",
  "home.pulse.label": "Quick summary",
  "home.pulse.actions": "pending actions",
  "home.pulse.inProgress": "active projects and services",
  "home.pulse.openInvoices": "open invoices",
  "home.pulse.overdue.one": "open invoices · {count} overdue",
  "home.pulse.overdue.other": "open invoices · {count} overdue",
  "home.pulse.tickets": "active tickets",
  "home.pulse.waitingYou.one": "active tickets · {count} waiting for you",
  "home.pulse.waitingYou.other": "active tickets · {count} waiting for you",
  "publicHome.feature.projects": "Your project stages, deliverables and approvals",
  "publicHome.feature.billing": "Invoices and payments with live status",
  "publicHome.feature.support": "Support with full conversation history",
} satisfies Record<keyof typeof ptBR, string>;

export const es = {
 "billing.invoice.download":"Descargar factura PDF",
 "billing.receipt.ownerMissing":"El PDF muestra los importes y el pago registrado en Cashier. El comprobante bancario es un documento separado; solicítelo a soporte cuando no esté disponible.",
"contracts.signer":"Firmante registrado",
"contracts.validatedAt":"Validación registrada el",
"contracts.evidence.MANUAL_VALIDATION":"Validación manual registrada en Stargate",
"contracts.evidence.PROVIDER_RECORDED":"Proveedor de firma registrado",
"contracts.evidence.NOT_AVAILABLE":"Evidencias de firma no disponibles",
"contracts.firstPage":"Primera página",
"contracts.lastPage":"Última página",
"contracts.previousPage":"Página anterior",
"contracts.nextPage":"Página siguiente",
"contracts.pageOf":"Página {page} de {total}",
"contracts.previewError":"No se pudo cargar el contrato. Actualiza la página o contacta con soporte.",
"contracts.originalFile": "Contrato original registrado en Stargate",
"contracts.openOriginal": "Abrir contrato completo en PDF",
"contracts.signedFileMissing":"Hay datos de firma registrados, pero el archivo firmado y el certificado de firma aún no están disponibles. Solicite el documento completo a Cupcode.",

 "services.deliveryDate":"Fecha de entrega registrada",
  "services.view": "Ver servicio",
  "billing.phase.INITIAL_50": "Pago inicial · 50%",
  "billing.phase.CLOSING_50": "Pago final · 50% restante en la entrega",
  "support.openTicket": "Abrir caso",
  "support.whatsapp": "Hablar por WhatsApp",

  "approvals.reasonRequired": "Indique el motivo para solicitar cambios o rechazar",
  "approvals.deadline": "Fecha límite",
  "approvals.reject": "Rechazar",
  "approvals.status.REJECTED": "Rechazada",
  "approvals.history.REJECTED": "Versión rechazada",
  "collaboration.files.title": "Archivos",
  "collaboration.files.add": "Subir archivo",
  "collaboration.files.allowed": "PDF, imágenes o texto, hasta 10 MB",
  "collaboration.files.download": "Descargar",
  "collaboration.files.invalid": "Tipo o tamaño de archivo no válido",
  "collaboration.files.uploading": "Subiendo archivo",
  "collaboration.files.scanPending": "Archivo recibido, esperando la verificación de seguridad",
  "collaboration.files.error": "No se pudo completar la operación del archivo",
  "collaboration.files.refresh": "Actualizar archivos",
  "collaboration.requests.title": "Solicitudes",
  "collaboration.requests.subtitle": "Información y archivos solicitados por Cupcode",
  "collaboration.requests.empty": "No hay solicitudes publicadas para usted",
  "collaboration.requests.view": "Ver solicitud",
  "collaboration.requests.deadline": "Fecha límite",
  "collaboration.requests.response": "Su respuesta",
  "collaboration.requests.authorize": "Confirmo la autorización presentada",
  "collaboration.requests.submit": "Enviar respuesta",
  "collaboration.requests.submitting": "Enviando respuesta",
  "collaboration.requests.submitted": "Respuesta enviada para revisión",
  "collaboration.requests.stale": "La solicitud cambió. Actualice antes de responder",
  "collaboration.requests.error": "No se pudo enviar la respuesta",
  "collaboration.requests.readOnly": "Consulte la información de esta solicitud",
  "collaboration.deliverables.title": "Entrega",
  "collaboration.deliverables.published": "Publicada para usted",
  "collaboration.deliverables.version": "Versión",
  "collaboration.deliverables.publishedAt": "Publicada el",
  "decisions.listTitle": "Decisiones",
  "decisions.subtitle": "Elecciones que Cupcode necesita de ti.",
  "decisions.empty": "No hay decisiones disponibles.",
  "collaboration.deliverables.listTitle": "Entregas",
  "collaboration.deliverables.subtitle": "Entregas publicadas para ti.",
  "collaboration.deliverables.empty": "A\u00fan no hay entregas publicadas.",
  "help.title": "Centro de ayuda",
  "help.subtitle": "Respuestas r\u00e1pidas a las dudas m\u00e1s comunes.",
  "help.empty": "No hay art\u00edculos disponibles por ahora.",
  "help.openCenter": "Abrir centro de soporte",
  "upgrade.badge": "Upgrade disponible",
  "upgrade.cta": "Ver upgrade",
  "upgrade.card.title": "{service}: pasa al {target}",
  "upgrade.card.body": "Pasa del {current} al {target} por {difference} m\u00e1s.",
  "upgrade.perMonth": "/mes",
  "upgrade.perYear": "/a\u00f1o",
  "upgrade.modal.title": "Upgrade de {service}",
  "upgrade.modal.description": "Del {current} al {target}.",
  "upgrade.modal.current": "Plan actual",
  "upgrade.modal.new": "Nuevo plan",
  "upgrade.modal.difference": "Diferencia",
  "upgrade.modal.note": "Enviamos la solicitud al equipo Cupcode, que confirma el cambio contigo. No se cobra nada ahora.",
  "upgrade.modal.noPermission": "Tu acceso no permite solicitar upgrades. Habla con el equipo Cupcode.",
  "upgrade.modal.submit": "Solicitar upgrade",
  "upgrade.modal.cancel": "Ahora no",
  "upgrade.sent": "Solicitud de upgrade enviada.",
  "upgrade.error": "No se pudo enviar la solicitud ahora. Int\u00e9ntalo de nuevo.",
  "upgrade.request.subject": "Upgrade de {service}: {current} a {target}",
  "upgrade.request.text": "\u00a1Hola! Me gustar\u00eda hacer el upgrade de {service} del plan {current} al {target} ({price}, {difference} m\u00e1s). \u00bfPueden ayudarme con los pr\u00f3ximos pasos?",
  "navigation.ads": "Anuncios",
  "ads.title": "Anuncios",
  "ads.subtitle": "Rendimiento de tus campa\u00f1as de tr\u00e1fico pago.",
  "ads.demo.badge": "Datos de demostraci\u00f3n",
  "ads.demo.note": "Estas cifras son ilustrativas. Conectaremos la cuenta de anuncios de tu empresa para mostrar los datos reales.",
  "ads.period.label": "Per\u00edodo",
  "ads.period.7": "7 d\u00edas",
  "ads.period.30": "30 d\u00edas",
  "ads.period.90": "90 d\u00edas",
  "ads.kpis": "Indicadores del per\u00edodo",
  "ads.vsPrevious": "vs. per\u00edodo anterior",
  "ads.unavailable": "No se pudieron cargar los datos de anuncios ahora.",
  "ads.metric.spend": "Inversi\u00f3n",
  "ads.metric.impressions": "Impresiones",
  "ads.metric.clicks": "Clics",
  "ads.metric.conversions": "Conversiones",
  "ads.metric.revenue": "Ingresos",
  "ads.metric.ctr": "CTR",
  "ads.metric.cpc": "CPC",
  "ads.metric.cpa": "CPA",
  "ads.metric.roas": "ROAS",
  "ads.chart.title": "Evoluci\u00f3n diaria",
  "ads.chart.metric": "M\u00e9trica del gr\u00e1fico",
  "ads.chart.summary": "{metric} por d\u00eda, del {from} al {to}",
  "ads.campaigns.title": "Campa\u00f1as",
  "ads.campaigns.name": "Campa\u00f1a",
  "ads.campaigns.platform": "Plataforma",
  "ads.platform.GOOGLE_ADS": "Google Ads",
  "ads.platform.META_ADS": "Meta Ads",
  "ads.status.ACTIVE": "Activa",
  "ads.status.PAUSED": "Pausada",
  "profile.title": "Completa el perfil de tu empresa",
  "profile.description": "Toma menos de un minuto y ayuda a Cupcode a atender mejor a {company}.",
  "profile.employees.label": "\u00bfCu\u00e1ntos empleados tiene la empresa?",
  "profile.employees.placeholder": "Selecciona",
  "profile.employees.1": "Solo yo",
  "profile.employees.2-10": "2 a 10",
  "profile.employees.11-50": "11 a 50",
  "profile.employees.51-200": "51 a 200",
  "profile.employees.201-500": "201 a 500",
  "profile.employees.500+": "M\u00e1s de 500",
  "profile.segment.label": "Sector",
  "profile.segment.placeholder": "Ej.: moda femenina, cl\u00ednica dental",
  "profile.website.label": "Sitio web (opcional)",
  "profile.website.placeholder": "empresa.com",
  "profile.about.label": "A qu\u00e9 se dedica la empresa, en pocas palabras (opcional)",
  "profile.save": "Guardar perfil",
  "profile.later": "Record\u00e1rmelo despu\u00e9s",
  "profile.saved": "Perfil guardado. \u00a1Gracias!",
  "profile.error.validation": "Revisa los campos e int\u00e9ntalo de nuevo.",
  "profile.error.forbidden": "Tu acceso no permite editar el perfil.",
  "profile.error.unavailable": "No se pudo guardar ahora. Int\u00e9ntalo de nuevo.",
  "agenda.title": "Agenda",
  "agenda.subtitle": "Tus pr\u00f3ximas reuniones y los horarios disponibles para agendar.",
  "agenda.upcoming.title": "Pr\u00f3ximas reuniones",
  "agenda.upcoming.empty": "No tienes reuniones agendadas.",
  "agenda.duration": "{minutes} min",
  "agenda.status.SCHEDULED": "Agendada",
  "agenda.status.CONFIRMED": "Confirmada",
  "agenda.cancel": "Cancelar",
  "agenda.cancel.title": "\u00bfCancelar esta reuni\u00f3n?",
  "agenda.cancel.description": "La reuni\u00f3n del {when} se cancelar\u00e1 y el horario volver\u00e1 a estar disponible.",
  "agenda.cancel.confirm": "Cancelar reuni\u00f3n",
  "agenda.cancel.keep": "Mantener",
  "agenda.cancelled": "Reuni\u00f3n cancelada.",
  "agenda.book.title": "Agendar reuni\u00f3n",
  "agenda.book.pickDay": "Elige un d\u00eda con horarios disponibles.",
  "agenda.book.pickTime": "Horarios disponibles el {day}",
  "agenda.book.noSlots": "No hay horarios disponibles este mes.",
  "agenda.book.topic": "Asunto (opcional)",
  "agenda.book.confirm": "Confirmar agendamiento",
  "agenda.book.review.title": "\u00bfConfirmar reuni\u00f3n?",
  "agenda.book.review.back": "Volver",
  "errors.noNaveAccess.title": "Sin acceso a Nave",
  "errors.noNaveAccess.body": "Tu cuenta Cupcode est\u00e1 activa, pero a\u00fan no tiene acceso a Nave. Pide acceso al administrador de tu empresa o al equipo Cupcode, o inicia sesi\u00f3n con otra cuenta.",
  "navigation.adsDemo": "Anuncios (demo)",
  "agenda.book.select": "Seleccionar",
  "agenda.book.chosen": "Seleccionado",
  "agenda.join": "Entrar en la videollamada",
  "agenda.booked.email": "Enviamos a tu correo la confirmaci\u00f3n con el enlace de la videollamada y la invitaci\u00f3n de calendario.",
  "support.sender.you": "T\u00fa",
  "support.conversation.waitingCupcode": "El equipo de Cupcode responder\u00e1 aqu\u00ed. Tambi\u00e9n recibes un aviso cuando llegue la respuesta.",
  "support.conversation.waitingClient": "El equipo respondi\u00f3 y te espera. Responde abajo para continuar.",
  "support.conversation.closed": "Este caso fue cerrado. Si lo necesitas, responde abajo para reabrir la conversaci\u00f3n.",
  "support.reply.placeholder": "Escribe tu respuesta\u2026",
  "support.reply.hint": "Ctrl + Enter para enviar",
  "upgrade.progress.label": "Pasos del upgrade",
  "upgrade.progress.sign": "Firmar el contrato",
  "upgrade.progress.signed": "Contrato firmado",
  "upgrade.progress.signDetail": "Enviamos el contrato a {email}. Abre el correo, revisa los t\u00e9rminos y firma.",
  "upgrade.progress.signSendFailed": "No pudimos enviar el correo del contrato ahora. Int\u00e9ntalo de nuevo.",
  "upgrade.progress.send": "Enviar contrato por correo",
  "upgrade.progress.resend": "Reenviar correo",
  "upgrade.progress.pay": "Pagar {amount}",
  "upgrade.progress.paid": "Pago confirmado",
  "upgrade.progress.payDetail": "Diferencia proporcional del upgrade. En cuanto se confirme el pago, el nuevo plan entra en vigor.",
  "upgrade.progress.payNow": "Pagar {amount}",
  "upgrade.progress.activate": "Plan {target} activo",
  "upgrade.progress.active": "Plan {target} activo",
  "upgrade.progress.activeDetail": "Nuestro equipo ya fue avisado y configurar\u00e1 todo contigo.",
  "upgrade.progress.checkInbox": "\u00bfNo encuentras el correo? Revisa tambi\u00e9n la carpeta de spam.",
  "upgrade.progress.sent": "Contrato enviado por correo.",
  "upgrade.progress.close": "Cerrar",
  "upgrade.status.badge": "Upgrade en curso",
  "upgrade.status.badgeActive": "Upgrade activo",
  "upgrade.status.sign": "Firma el contrato de {target}",
  "upgrade.status.signBody": "Enviamos el contrato por correo. Solo falta firmar.",
  "upgrade.status.pay": "Paga {amount} para activar {target}",
  "upgrade.status.payBody": "Contrato firmado. El nuevo plan empieza en cuanto se confirme el pago.",
  "upgrade.status.active": "{target} activo",
  "upgrade.status.activeBody": "Pago confirmado. Nuestro equipo configurar\u00e1 todo contigo.",
  "upgrade.status.ctaSign": "Ver pasos",
  "upgrade.status.ctaPay": "Pagar ahora",
  "upgrade.status.ctaActive": "Ver detalles",
  "upgrade.self.cta": "Contratar upgrade",
  "upgrade.self.step1": "Confirmas y el contrato va al correo del representante legal ({email}).",
  "upgrade.self.step2": "Se firma digitalmente, con verificaci\u00f3n por c\u00f3digo.",
  "upgrade.self.step3": "Pagas {amount}, la diferencia proporcional de los {remaining} d\u00edas que quedan del ciclo.",
  "upgrade.self.step4": "Tu plan cambia a {target} y nuestro equipo configura todo contigo.",
  "upgrade.self.error.changed": "El valor cambi\u00f3. Revisa el nuevo valor y confirma de nuevo.",
  "upgrade.self.error.inProgress": "Ya hay un upgrade en curso para este servicio.",
  "upgrade.self.error.noRepresentative": "No encontramos al representante legal de la empresa. Habla con el equipo para completar el upgrade.",
  "upgrade.self.error.contract": "No pudimos preparar el contrato ahora. Int\u00e9ntalo de nuevo o p\u00eddelo por soporte.",
  "upgrade.quote.now": "Para cambiar ahora",
  "upgrade.quote.nowDetail": "Diferencia proporcional: {remaining} de {total} d\u00edas restantes del ciclo actual",
  "upgrade.quote.from": "A partir del {date}",
  "upgrade.quote.fromDetail": "Valor de {target} en cada ciclo",
  "upgrade.modal.step3Quote": "Despu\u00e9s de la confirmaci\u00f3n pagas {amount} y el nuevo plan entra en vigor. No se cobra nada ahora.",
  "upgrade.request.quote": "Valor proporcional informado en el portal: {amount} ({remaining} de {total} d\u00edas del ciclo actual); valor completo a partir del {date}.",
  "upgrade.includes.keptCount": "Ver los {count} elementos que mantienes",
  "upgrade.includes.titleCompare": "Lo que ganas con {target}",
  "upgrade.includes.titleAll": "Lo que incluye {target}",
  "upgrade.includes.new": "Nuevo",
  "questionnaires.draftSaved": "Borrador guardado.",
  "questionnaires.completed": "Cuestionario completado. \u00a1Gracias!",
  "approvals.reasonMissing": "Escribe el motivo en el comentario antes de pedir cambios o rechazar.",
  "profile.cta": "Completar perfil",
  "upgrade.modal.yourPlan": "Tu plan",
  "upgrade.modal.how": "C\u00f3mo funciona",
  "upgrade.modal.step1": "Env\u00edas la solicitud desde aqu\u00ed.",
  "upgrade.modal.step2": "El equipo Cupcode confirma los detalles contigo.",
  "upgrade.modal.step3": "El plan solo cambia despu\u00e9s de tu confirmaci\u00f3n. No se cobra nada ahora.",
  "home.attention.cta.review": "Revisar",
  "home.attention.cta.choose": "Elegir",
  "home.attention.cta.respond": "Responder",
  "home.attention.cta.open": "Abrir",
  "collaboration.files.none": "Ning\u00fan archivo adjunto.",
  "collaboration.files.choose": "Elegir archivo",
  "notifications.subtitle": "Avisos sobre pagos y actualizaciones de tu cuenta.",
  "notifications.refresh": "Actualizar",
  "notifications.unreadCount.one": "{count} sin leer",
  "notifications.unreadCount.other": "{count} sin leer",
  "agenda.legend.title": "Leyenda del calendario",
  "agenda.legend.available": "Disponible",
  "agenda.legend.holiday": "Feriado",
  "agenda.legend.selected": "Seleccionado",
  "agenda.holiday.newYear": "Confraternizaci\u00f3n Universal",
  "agenda.holiday.carnival": "Carnaval",
  "agenda.holiday.goodFriday": "Viernes Santo",
  "agenda.holiday.tiradentes": "Tiradentes",
  "agenda.holiday.labour": "D\u00eda del Trabajo",
  "agenda.holiday.corpusChristi": "Corpus Christi",
  "agenda.holiday.independence": "Independencia de Brasil",
  "agenda.holiday.ourLady": "Nuestra Se\u00f1ora Aparecida",
  "agenda.holiday.allSouls": "D\u00eda de los Difuntos",
  "agenda.holiday.republic": "Proclamaci\u00f3n de la Rep\u00fablica",
  "agenda.holiday.blackAwareness": "Conciencia Negra",
  "agenda.holiday.christmas": "Navidad",
  "agenda.book.selected": "{day} a las {time} \u00b7 {minutes} min",
  "agenda.book.timezone": "Horarios en la zona {zone}.",
  "agenda.book.notice": "Agenda con al menos {hours} h de anticipaci\u00f3n.",
  "agenda.booked": "Reuni\u00f3n agendada: {when}.",
  "agenda.book.noPermission": "Tu acceso no permite agendar reuniones. Habla con el equipo Cupcode.",
  "agenda.error.taken": "Ese horario acaba de ser ocupado. Elige otro.",
  "agenda.error.validation": "Revisa los datos e int\u00e9ntalo de nuevo.",
  "agenda.error.forbidden": "Tu acceso no permite esta acci\u00f3n.",
  "agenda.error.unavailable": "No se pudo completar ahora. Int\u00e9ntalo de nuevo.",
  "agenda.unavailable": "No se pudo cargar la agenda ahora.",
  "calendar.previous": "Mes anterior",
  "calendar.next": "Mes siguiente",
  "agenda.admin.title": "Disponibilidad del equipo",
  "agenda.admin.description": "Define los d\u00edas y horarios en que los clientes pueden agendar reuniones.",
  "agenda.admin.weekday": "D\u00eda de la semana",
  "agenda.admin.start": "Inicio",
  "agenda.admin.end": "Fin",
  "agenda.admin.slot": "Duraci\u00f3n",
  "agenda.admin.active": "Activo",
  "agenda.admin.slotMinutes": "{minutes} min",
  "agenda.admin.addRule": "Agregar horario",
  "agenda.admin.removeRule": "Quitar horario",
  "agenda.admin.empty": "Ning\u00fan horario definido. Los clientes no pueden agendar.",
  "agenda.admin.blocks": "Fechas bloqueadas",
  "agenda.admin.blockDate": "Fecha",
  "agenda.admin.blockReason": "Motivo (opcional)",
  "agenda.admin.addBlock": "Bloquear fecha",
  "agenda.admin.removeBlock": "Quitar bloqueo",
  "agenda.admin.save": "Guardar disponibilidad",
  "agenda.admin.saved": "Disponibilidad guardada.",
  "navigation.group.work": "Colaboraci\u00f3n",
  "navigation.group.commercial": "Finanzas y contratos",
  "navigation.group.service": "Soporte y ayuda",
  "collaboration.requests.status.WAITING_CLIENT": "Esperando su respuesta",
  "collaboration.requests.status.SUBMITTED": "Enviada para revisión",
  "collaboration.requests.status.UNDER_REVIEW": "En revisión",
  "collaboration.requests.status.COMPLETED": "Completada",
  "collaboration.requests.status.CANCELLED": "Cancelada",
  "collaboration.requests.status.EXPIRED": "Expirada",
  "collaboration.requests.status.SUPERSEDED": "Reemplazada",

  "documents.download": "Descargar documento",
  "documents.downloadError": "No se pudo descargar el documento",
  "documents.version": "Versión",
  "questionnaires.choose": "Elija una opción",
  "questionnaires.submit": "Completar cuestionario",
  "questionnaires.versionConflict": "La versión cambió. Actualice el cuestionario antes de responder",
  "questionnaires.required": "Complete los campos obligatorios",
  "questionnaires.submitError": "No se pudieron guardar sus respuestas",
  "questionnaires.save": "Guardar borrador",

  "contracts.status.PENDING_SIGNATURE": "Pendiente de firma",
  "contracts.status.SUPERSEDED": "Sustituido",
  "contracts.status.CANCELLED": "Cancelado",

  "billing.service": "Servicio contratado",
  "billing.plan": "Plan",
  "billing.contract": "Contrato",
  "billing.competence": "Mes de facturación",
  "billing.period.title": "Período de facturación",
  "billing.subtotal": "Subtotal",
  "billing.additions": "Recargos",
  "billing.amountPaid": "Importe pagado",
  "billing.payment.title": "Pago",
  "billing.payment.explanation": "Complete el pago en el checkout seguro de Cashier. Al volver, consulte el estado actualizado.",
  "billing.payment.cashier": "Pagar en Cashier",
  "billing.payment.unavailable": "El pago de esta factura no está disponible temporalmente. Contacte con soporte.",
  "billing.payment.refresh": "Actualizar estado",
  "billing.history.title": "Pagos confirmados",
  "billing.history.empty": "No hay pagos confirmados en esta factura.",
  "billing.method.PIX": "Pix",
  "billing.method.CARD": "Tarjeta",
  "billing.method.BOLETO": "Boleto",

  "platform.admin": "Administración de la plataforma",
  "platform.search": "Buscar organización",
  "platform.viewing": "Visualizando: {organization}",
  "platform.return": "Salir de la vista de cliente",
  "organization.switchFailed": "No se pudo cambiar de organización. Inténtalo de nuevo.",

  "app.name": "Nave",
  "app.tagline": "Tu espacio Cupcode",
  "navigation.home": "Inicio",
  "navigation.foundation": "Foundation V0.1",
  "organization.label": "Organización",
  "organization.switch": "Cambiar organización",
  "organization.single": "Organización activa",
  "language.label": "Idioma",
  "language.ptBR": "Português",
  "language.en": "English",
  "language.es": "Español",
  "theme.label": "Tema",
  "theme.light": "Claro",
  "theme.dark": "Oscuro",
  "scenario.label": "Escenario de desarrollo",
  "user.menu": "Menú de la cuenta",
  "user.emailUnavailable": "Correo no disponible",
  "production.unavailable.title": "Nave no está disponible en este entorno",
  "production.unavailable.body": "Las integraciones de producción necesarias aún no están configuradas. No se usarán datos de demostración como sustituto.",
  "production.profileUnavailable.title": "Tu sesión fue reconocida",
  "production.profileUnavailable.body": "No se pudieron cargar tu organización y los datos de cliente de forma segura. No se mostrarán datos de demostración.",
  "publicHome.title": "Bienvenido a tu Nave Cupcode",
  "publicHome.description": "Sigue tus proyectos, servicios, documentos, finanzas y soporte en una experiencia única.",
  "publicHome.signIn": "Iniciar sesión con Cupcode",
  "publicHome.loginUnavailable": "No se pudo iniciar sesión. Inténtelo de nuevo en unos instantes.",
  "publicHome.returnNotice": "Después de iniciar sesión, volverás a la página solicitada.",
  "production.organization.choose": "Elige una organización",
  "production.organization.none": "No hay una organización activa vinculada a tu cuenta.",
  "production.dashboard.sections": "Datos de tu organización",
  "production.dashboard.services": "Servicios",
  "production.dashboard.projects": "Proyectos",
  "production.dashboard.integrationUnavailable": "Todavía no se pudieron cargar datos reales de esta área.",
  "production.dashboard.loading": "Cargando los datos de tu organización…",
  "production.dashboard.projectsEmpty": "No hay proyectos publicados para ti en esta organización.",
  "production.project.back": "Volver a Proyectos y Servicios",
  "services.status.PAUSED": "Pausado",
  "services.status.COMPLETED": "Completado",
  "services.status.ENDED": "Finalizado",
  "services.status.UNAVAILABLE": "Estado no disponible",
  "account.authRequired.title": "Inicia sesión para continuar",
  "account.authRequired.body": "Tu sesión no está autenticada. Inicia sesión mediante Cupcode Accounts para continuar en Nave.",
  "account.authRequired.afterLogoutBody": "Tu sesión local de Nave terminó. Inicia sesión nuevamente para continuar.",
  "account.sessionExpired.title": "Tu sesión expiró",
  "account.sessionExpired.body": "Por seguridad, debes iniciar sesión nuevamente para continuar.",
  "account.loginCancelled.title": "Inicio de sesión cancelado",
  "account.loginCancelled.body": "El inicio de sesión fue cancelado. Puedes intentarlo de nuevo cuando quieras.",
  "account.actions.signIn": "Iniciar sesión",
  "account.actions.signOut": "Cerrar sesión",
  "account.actions.signInAgain": "Iniciar sesión de nuevo",
  "account.actions.restart": "Reiniciar inicio de sesión",
  "account.authAction.notConnected": "La conexión con Cupcode Accounts se habilitará en una etapa posterior de la integración.",
  "account.callback.title": "Validando tu inicio de sesión",
  "account.callback.body": "Estamos completando la verificación antes de abrir tu experiencia en Nave.",
  "account.callback.loading": "Validando inicio de sesión",
  "organization.selection.title": "Elige una organización",
  "organization.selection.description": "Selecciona una organización disponible para continuar.",
  "organization.selection.label": "Organización disponible",
  "organization.selection.placeholder": "Selecciona una organización",
  "organization.selection.continue": "Continuar",
  "organization.unavailable.title": "Organización no disponible",
  "organization.unavailable.body": "No es posible habilitar esta organización de forma segura en este momento.",
  "errors.accountsUnavailable.title": "Servicio de cuenta temporalmente no disponible",
  "errors.accountsUnavailable.body": "No pudimos confirmar tu cuenta ahora. Inténtalo de nuevo más tarde.",
  "errors.membershipRequired.title": "Acceso de cliente no encontrado",
  "errors.membershipRequired.body": "Tu cuenta está autenticada, pero no hay un acceso de cliente elegible disponible en Nave.",
  "errors.invalidEntryContext.title": "No se pudo validar este acceso",
  "errors.invalidEntryContext.body": "La entrada recibida no es válida o no puede usarse de forma segura. Inicia el flujo nuevamente.",
  "errors.expiredEntryContext.title": "Esta entrada expiró",
  "errors.expiredEntryContext.body": "La entrada expiró y debe iniciarse nuevamente.",
  "errors.resourceConflict.title": "Esta acción ya no está disponible",
  "errors.resourceConflict.body": "El estado de este elemento cambió. Actualiza la experiencia antes de intentarlo de nuevo.",
  "home.health.READY": "Actualizado",
  "home.health.PARTIAL": "Parcial",
  "home.health.STALE": "Puede estar desactualizado",
  "home.health.UNAVAILABLE": "No disponible",
  "priority.LOW": "Baja",
  "priority.NORMAL": "Normal",
  "priority.HIGH": "Alta",
  "priority.CRITICAL": "Crítica",
  "services.status.ACTIVE": "Activo",
  "products.name.telescup": "Telescup",
  "products.name.aidar-seo": "AiDAR SEO",
  "products.name.aidar-copy": "AiDAR Copy",
  "products.name.cupcode-host": "Cupcode Host",
  "products.title": "Productos",
  "products.empty": "No hay ningún producto digital contratado disponible para el cliente seleccionado.",
  "products.plan": "Plan / referencia",
  "products.limits": "Límites contratados",
  "products.open": "Abrir producto",
  "products.access.ALLOWED": "El acceso está autorizado para este usuario.",
  "products.access.DENIED": "No tienes acceso a esta aplicación.",
  "products.access.UNAVAILABLE": "No fue posible confirmar tu acceso a esta aplicación en este momento.",
  "products.status.ACTIVE": "Activo",
  "products.status.INACTIVE": "Inactivo",
  "products.status.SUSPENDED": "Suspendido",
  "activity.generic": "Actualización disponible",
  "home.greeting": "Resumen",
  "home.subtitle": "Lo que necesita tu atención y lo que está ocurriendo ahora.",
  "home.attention.title": "Te necesita",
  "home.attention.empty": "Nada necesita tu acción ahora.",
  "home.progress.title": "En curso",
  "home.progress.empty": "No hay proyectos o servicios activos.",
  "home.billing.title": "Finanzas",
  "home.billing.empty": "No hay cobros relevantes ahora.",
  "home.usage.title": "Productos y uso",
  "home.usage.empty": "No hay alertas de uso relevantes.",
  "home.support.title": "Soporte",
  "home.support.empty": "No hay casos de soporte activos relevantes.",
  "home.activity.title": "Actividad reciente",
  "home.activity.empty": "No hay actividad reciente.",
  "state.loading": "Cargando…",
  "state.stale": "Los datos pueden estar desactualizados.",
  "state.unavailable": "Esta sección no está disponible temporalmente.",
  "state.partial": "Parte de la información no está disponible temporalmente.",
  "section.state.READY": "Disponible",
  "section.state.STALE": "Desactualizado",
  "section.state.EMPTY": "Vacío",
  "section.state.UNAVAILABLE": "No disponible",
  "errors.generic.title": "No se pudo cargar esta área",
  "errors.generic.body": "Inténtalo de nuevo o continúa usando las demás áreas disponibles.",
  "errors.forbidden.title": "Acceso no disponible",
  "errors.forbidden.body": "Este contenido no está disponible con tu acceso actual.",
  "errors.unavailable.title": "Servicio temporalmente no disponible",
  "errors.unavailable.body": "Una dependencia necesaria no respondió. Las demás áreas siguen disponibles cuando sea posible.",
  "errors.notFound.title": "Página no encontrada",
  "errors.notFound.body": "La dirección puede ser incorrecta o la página aún no existe en esta versión.",
  "errors.notFound.back": "Volver al inicio",
  "billing.nextInvoice": "Próximo cobro",
  "billing.overdue": "Vencida",
  "billing.open": "Abierta",
  "billing.due": "Vencimiento",
  "navigation.billing": "Finanzas",
  "navigation.support": "Soporte",
  "billing.page.title": "Finanzas",
  "billing.page.subtitle": "Consulta tus facturas y los importes informados por el sistema financiero de Cupcode.",
  "billing.summary.title": "Situación financiera",
  "billing.summary.open": "Abiertas",
  "billing.summary.overdue": "Vencidas",
  "client.label": "Cliente",
  "client.search": "Buscar cliente",
  "client.choose": "Seleccionar cliente",
  "client.selectionRequired": "Selecciona un cliente arriba para consultar su información.",
  "client.test": "Cliente de prueba",
  "billing.noFinancialAccount": "Seleccione un cliente para consultar sus facturas. Las otras áreas siguen disponibles.",
  "billing.summary.clear": "Todo está al día con tus cobros en este momento.",
  "billing.invoices.title": "Facturas",
  "billing.invoices.empty": "No hay facturas disponibles para el cliente seleccionado.",
  "billing.invoices.loadMore": "Cargar más facturas",
  "billing.invoices.loadingMore": "Cargando más facturas…",
  "billing.invoices.loadMoreError": "No se pudieron cargar más facturas ahora.",
  "billing.invoice.label": "Factura",
  "billing.invoice.view": "Ver factura",
  "billing.invoice.detailTitle": "Factura {id}",
  "billing.invoice.summary": "Resumen de la factura",
  "billing.invoice.status.open": "Abierta",
  "billing.invoice.status.overdue": "Vencida",
  "billing.invoice.status.paid": "Pagada",
  "billing.invoice.status.cancelled": "Cancelada",
  "billing.payment.status.pending": "Pendiente",
  "billing.payment.status.processing": "En procesamiento",
  "billing.payment.status.paid": "Pagado",
  "billing.payment.status.failed": "Falló",
  "billing.payment.status.cancelled": "Cancelado",
  "billing.payment.status.refunded": "Reembolsado",
  "billing.total": "Importe total",
  "billing.balance": "Saldo",
  "billing.paymentStatus": "Estado del pago",
  "billing.issuedAt": "Emitida el",
  "billing.paidAt": "Pagada el",
  "billing.items.title": "Ítems de la factura",
  "billing.period.unspecified": "Período no informado",
  "billing.errors.forbidden.title": "Finanzas no disponibles para este acceso",
  "billing.errors.forbidden.body": "Tu acceso actual no permite consultar la información financiera de esta organización.",
  "billing.errors.notFound.title": "Factura no encontrada",
  "billing.errors.notFound.body": "Esta factura no está disponible para el cliente seleccionado o para tu alcance de acceso.",
  "billing.errors.unavailable.title": "Finanzas no disponibles temporalmente",
  "billing.errors.unavailable.body": "No fue posible consultar el sistema financiero ahora. Las demás áreas de Nave siguen disponibles.",
  "billing.errors.generic.title": "No se pudo cargar Finanzas",
  "billing.errors.generic.body": "Ocurrió un error inesperado al cargar esta área.",
  "projects.status.IN_PROGRESS": "En curso",
  "projects.status.WAITING_CLIENT": "Esperándote",
  "projects.status.COMPLETED": "Completado",
  "projects.stage.development": "Desarrollo",
  "usage.threshold.SOFT_LIMIT": "Cerca del límite",
  "usage.threshold.HARD_LIMIT": "Límite alcanzado",
  "usage.title": "Uso del producto",
  "usage.empty": "No hay métricas de uso disponibles para este producto.",
  "usage.unavailable": "Los datos de uso de este producto no están disponibles temporalmente.",
  "usage.used": "Usado",
  "usage.included": "Incluido",
  "usage.remaining": "Restante",
  "usage.softLimit": "Límite de atención",
  "usage.hardLimit": "Límite máximo",
  "usage.overage": "Excedente",
  "usage.periodStart": "Inicio del período",
  "usage.periodEnd": "Fin del período",
  "usage.resetAt": "Renovación del período",
  "usage.updatedAt": "Actualizado el",
  "usage.metric.storage": "Almacenamiento",
  "usage.metric.analyses": "Análisis",
  "usage.unit.analysis.one": "análisis",
  "usage.unit.analysis.other": "análisis",
  "usage.limit.SOFT_LIMIT": "Atención al límite",
  "usage.limit.HARD_LIMIT": "Límite alcanzado",
  "attention.action.project": "Proyecto esperando tu acción",
  "attention.action.support": "Responder al soporte",
  "activity.invoicePaid": "Pago confirmado",
  "usage.assets": "Archivos",
  "usage.storage": "Almacenamiento",
  "usage.unit.assets.one":"archivo",
  "usage.unit.assets.other":"archivos",
  "usage.unit.credits.one":"crédito",
  "usage.unit.credits.other":"créditos",
  "usage.monitoredUrls": "URLs supervisadas",
  "usage.aiCredits": "Créditos de IA",
  "support.reply.title": "Responder al caso",
  "support.create.title": "Nuevo caso",
  "support.create.noServices": "No hay servicios disponibles para abrir un caso para este cliente.",
  "support.create.service": "Servicio",
  "support.create.subject": "Asunto",
  "support.message": "Mensaje",
  "support.sending": "Enviando…",
  "support.reply.send": "Enviar respuesta",
  "support.create.send": "Abrir caso",
  "support.validation": "Revisa el asunto y el mensaje antes de enviar.",
  "support.conflict": "Este intento ya se envió con otro contenido. Actualiza el caso antes de volver a intentarlo.",
  "notifications.title":"Notificaciones",
  "notifications.unavailable.title":"Notificaciones temporalmente no disponibles",
  "notifications.unavailable.body":"No se pudieron consultar tus notificaciones ahora. Las otras áreas siguen disponibles.",
  "notifications.empty":"No hay notificaciones disponibles para este cliente.",
  "notifications.read":"Leída",
  "notifications.unread":"No leída",
  "notifications.markRead":"Marcar como leída",
  "notifications.partial":"Mostrando notificaciones de pagos recientes.",
  "support.attachments":"Adjuntos",
  "support.download":"Descargar archivo",
  "support.chooseFile":"Seleccionar archivo",
  "support.upload":"Subir archivo",
  "support.attachmentError":"El archivo no está disponible ahora. Comprueba el tipo y el tamaño o espera la revisión de seguridad.",
  "support.attachment.pending":"Envío pendiente",
  "support.attachment.stored":"Archivo recibido",
  "support.attachment.clean":"Revisión completada",
  "support.attachment.blocked":"Archivo bloqueado",
  "support.attachment.error":"Error de revisión",
  "support.help":"Centro de ayuda",
  "support.helpEmpty":"No hay artículos publicados disponibles ahora.",
  "support.readArticle":"Leer artículo",
  "support.finalize":"Confirmar resolución",
  "support.reopen":"Reabrir caso",
  "support.actionError":"No se pudo actualizar el caso. Actualiza para confirmar su estado actual.",
  "support.conversation":"Conversación",
  "support.sender.CLIENT":"Cliente",
  "support.sender.CUPCODE":"Cupcode",
  "support.moreMessages":"Las 100 respuestas más recientes están disponibles en esta conversación.",
  "support.page.title": "Soporte",
  "support.page.subtitle": "Sigue los tickets disponibles para el cliente seleccionado y consulta quién está esperando la próxima actualización.",
  "support.summary.title": "Seguimiento reciente",
  "support.tickets.title": "Tickets",
  "support.tickets.empty": "No hay tickets disponibles para el cliente seleccionado.",
  "support.tickets.moreAvailable": "Hay otros tickets además de los que se muestran en esta página.",
  "support.tickets.loadMore": "Cargar más tickets",
  "support.tickets.loadingMore": "Cargando más tickets…",
  "support.tickets.loadMoreError": "No se pudieron cargar más tickets ahora.",
  "support.ticket.label": "Ticket",
  "support.ticket.view": "Ver ticket",
  "support.ticket.summary": "Resumen del ticket",
  "support.lastActivity": "Última actividad",
  "support.awaiting": "Esperando a",
  "support.awaiting.CUPCODE": "Cupcode",
  "support.awaiting.CLIENT": "Ti",
  "support.awaiting.NONE": "Nadie",
  "support.unread": "Sin leer",
  "support.serviceRef": "Servicio relacionado",
  "support.errors.forbidden.title": "Soporte no disponible para este acceso",
  "support.errors.forbidden.body": "Tu acceso actual no permite consultar los tickets del cliente seleccionado.",
  "support.errors.notFound.title": "Ticket no encontrado",
  "support.errors.notFound.body": "Este ticket no está disponible para el cliente seleccionado o alcance de acceso.",
  "support.errors.unavailable.title": "Soporte temporalmente no disponible",
  "support.errors.unavailable.body": "No fue posible consultar el sistema de soporte ahora. Las demás áreas de Nave siguen disponibles.",
  "support.errors.generic.title": "No se pudo cargar Soporte",
  "support.errors.generic.body": "Ocurrió un error inesperado al cargar esta área.",
  "support.status.WAITING_CUPCODE": "Esperando a Cupcode",
  "support.status.WAITING_CLIENT": "Esperándote",
  "support.status.IN_PROGRESS": "En atención",
  "support.status.RESOLVED": "Resuelto",
  "support.status.CLOSED": "Cerrado",
  "attention.action.approval": "Aprobación pendiente",
  "attention.action.clientRequest": "Información solicitada",
  "attention.action.payInvoice": "Factura vencida",
  "activity.project.stageChanged": "El proyecto avanzó de etapa",
  "common.updatedAt": "Actualizado",
  "common.items": "elementos",
  "common.open": "Abrir",
  "common.action": "Acción necesaria",
  "common.attention": "Atención",
  "common.information": "Información",
  "navigation.projectsServices": "Proyectos y servicios",
  "navigation.documents": "Documentos",
  "projectsServices.title": "Proyectos y servicios",
  "projectsServices.subtitle": "Sigue tus proyectos y servicios activos en un solo lugar.",
  "projects.title": "Proyectos",
  "projects.empty": "No tienes proyectos en curso en este momento.",
  "projects.view": "Ver proyecto",
  "projects.progress": "Progreso",
  "projects.currentStage": "Etapa actual",
  "projects.nextStage": "Siguiente etapa",
  "projects.nextMilestone": "Próximo hito",
  "projects.committedDate": "Fecha comprometida",
  "projects.requests": "Solicitudes",
  "projects.requestsCount.one": "{count} solicitud relacionada.",
  "projects.requestsCount.other": "{count} solicitudes relacionadas.",
  "projects.approvals": "Aprobaciones",
  "projects.approvalsCount.one": "{count} aprobación relacionada.",
  "projects.approvalsCount.other": "{count} aprobaciones relacionadas.",
  "projects.activity": "Actividad reciente",
  "services.title": "Servicios",
  "services.empty": "No hay servicios disponibles para el cliente seleccionado.",
  "documents.title": "Documentos",
  "documents.subtitle": "Contratos y propuestas disponibles para el cliente seleccionado.",
  "documents.reference": "Documento relacionado",
  "contracts.title": "Contratos",
  "contracts.untitled": "Contrato",
  "contracts.empty": "No hay contratos disponibles.",
  "contracts.view": "Ver contrato",
  "contracts.signedAt": "Firmado el",
  "contracts.startsAt": "Inicio",
  "contracts.endsAt": "Fin",
  "proposals.title": "Propuestas",
  "proposals.empty": "No hay propuestas disponibles.",
  "proposals.view": "Ver propuesta",
  "proposals.createdAt": "Creada el",
  "proposals.expiresAt": "Vence",
  "questionnaires.title": "Cuestionarios",
  "questionnaires.subtitle": "Revisa cuestionarios disponibles desde solicitudes y enlaces autorizados.",
  "questionnaires.empty": "No hay cuestionarios disponibles.",
  "questionnaires.dueAt": "Plazo",
  "questionnaires.review": "Revisar",
  "questionnaires.progress": "Progreso",
  "questionnaires.respondDeferred": "Este cuestionario puede requerir tu respuesta, pero la edición real permanece en el sistema responsable.",
  "questionnaires.readOnly": "Este cuestionario está disponible solo para revisión.",
  "common.back": "Volver",
  "common.retry": "Intentar de nuevo",
  "status.unknown": "Estado disponible",
  "projects.status.NOT_STARTED": "No iniciado",
  "projects.status.WAITING_CUPCODE": "Esperando a Cupcode",
  "projects.status.UNDER_REVIEW": "En revisión",
  "projects.status.SCHEDULED": "Programado",
  "projects.status.CANCELLED": "Cancelado",
  "contracts.status.ACTIVE": "Activo",
  "contracts.status.SIGNED": "Firmado",
  "contracts.status.EXPIRED": "Finalizado",
  "proposals.status.OPEN": "Abierta",
  "proposals.status.ACCEPTED": "Aceptada",
  "proposals.status.EXPIRED": "Expirada",
  "questionnaires.status.OPEN": "Abierto",
  "questionnaires.status.IN_PROGRESS": "En curso",
  "questionnaires.status.COMPLETED": "Completado",
  "approvals.eyebrow": "Colaboración",
  "approvals.title": "Aprobaciones",
  "approvals.subtitle": "Revisa las versiones enviadas y registra tu decisión cuando haya una acción disponible.",
  "approvals.empty": "No hay aprobaciones disponibles para el cliente seleccionado.",
  "approvals.view": "Ver aprobación",
  "approvals.untitled": "Aprobación",
  "approvals.version": "Versión {version}",
  "approvals.versionLabel": "Versión",
  "approvals.currentVersion": "Versión actual",
  "approvals.requestedAt": "Solicitada el",
  "approvals.completedAt": "Completada el",
  "approvals.artifactVersion": "Versión del artefacto",
  "approvals.actionsLabel": "Acciones de aprobación",
  "approvals.actionVersionNotice": "Tu decisión se registrará para la versión {version}.",
  "approvals.commentOptional": "Comentario opcional",
  "approvals.approve": "Aprobar esta versión",
  "approvals.requestChanges": "Solicitar cambios",
  "approvals.submitting": "Registrando tu decisión…",
  "approvals.success": "Decisión registrada correctamente.",
  "approvals.stale": "Hay una versión más reciente. Actualiza antes de responder.",
  "approvals.ownerUnavailable": "Esta aprobación pertenece a otro sistema y no puede responderse aquí ahora.",
  "approvals.actionError": "No se pudo registrar tu decisión ahora.",
  "approvals.readOnly": "Esta aprobación está disponible solo para consulta en este momento.",
  "approvals.externalOwnerReadOnly": "Esta aprobación está controlada por el sistema responsable y aquí está disponible solo para consulta.",
  "approvals.history": "Historial",
  "approvals.evidence": "Evidencia de la decisión",
  "approvals.history.VERSION_SUBMITTED": "Versión enviada",
  "approvals.history.APPROVED": "Versión aprobada",
  "approvals.history.CHANGES_REQUESTED": "Cambios solicitados",
  "approvals.history.SUPERSEDED": "Aprobación reemplazada",
  "approvals.history.CANCELLED": "Aprobación cancelada",
  "approvals.status.READY": "Lista para enviar",
  "approvals.status.WAITING_CLIENT": "Esperando tu acción",
  "approvals.status.APPROVED": "Aprobada",
  "approvals.status.CHANGES_REQUESTED": "Cambios solicitados",
  "approvals.status.SUPERSEDED": "Reemplazada",
  "approvals.status.CANCELLED": "Cancelada",
  "approvals.subject.homepage": "Página de inicio del sitio",
  "activity.approval.approved": "Aprobaste una versión",
  "activity.approval.changesRequested": "Solicitaste cambios en una versi\u00f3n",
  "attention.action.decision": "Una decisi\u00f3n necesita tu atenci\u00f3n",
  "requests.decision.title": "Elecci\u00f3n necesaria",
  "requests.decision.description": "Revisa las opciones y registra tu elecci\u00f3n.",
  "feedback.title": "Feedback",
  "feedback.subtitle": "Conversa sobre este contexto sin cambiar la decisi\u00f3n formal.",
  "feedback.empty": "A\u00fan no hay comentarios visibles para ti.",
  "feedback.commentLabel": "Tu comentario",
  "feedback.submit": "Enviar comentario",
  "feedback.submitting": "Enviando comentario\u2026",
  "feedback.success": "Comentario enviado.",
  "feedback.unavailable": "No pudimos cargar este feedback ahora.",
  "feedback.ownerUnavailable": "Este feedback pertenece a otro sistema y no puede enviarse desde aqu\u00ed ahora.",
  "feedback.closed": "Esta conversaci\u00f3n ya no acepta comentarios.",
  "feedback.validation": "Escribe un comentario antes de enviarlo.",
  "feedback.error": "No se pudo enviar tu comentario ahora.",
  "feedback.externalReadOnly": "Este feedback est\u00e1 controlado por el sistema responsable y aqu\u00ed est\u00e1 disponible solo para consulta.",
  "feedback.readOnly": "Este feedback est\u00e1 disponible solo para consulta en este momento.",
  "feedback.status.OPEN": "Abierto",
  "feedback.status.RESOLVED": "Resuelto",
  "feedback.status.CANCELLED": "Cancelado",
  "feedback.author.YOU": "T\u00fa",
  "feedback.author.CUSTOMER": "Cliente",
  "feedback.author.CUPCODE": "Cupcode",
  "decisions.eyebrow": "Colaboraci\u00f3n",
  "decisions.title": "Decisi\u00f3n",
  "decisions.untitled": "Elige una opci\u00f3n",
  "decisions.contextDefault": "Decisi\u00f3n solicitada",
  "decisions.context.project": "Proyecto",
  "decisions.prompt.homepageDirection": "\u00bfQu\u00e9 direcci\u00f3n debemos seguir para la p\u00e1gina de inicio?",
  "decisions.option.directionA": "Direcci\u00f3n A",
  "decisions.option.directionB": "Direcci\u00f3n B",
  "decisions.optionUntitled": "Opci\u00f3n",
  "decisions.optionsLabel": "Opciones disponibles",
  "decisions.submit": "Registrar elecci\u00f3n",
  "decisions.submitting": "Registrando elecci\u00f3n\u2026",
  "decisions.success": "Tu elecci\u00f3n fue registrada.",
  "decisions.stale": "Esta decisi\u00f3n fue actualizada. Revisa la versi\u00f3n m\u00e1s reciente antes de responder.",
  "decisions.ownerUnavailable": "Esta decisi\u00f3n pertenece a otro sistema y no puede responderse aqu\u00ed ahora.",
  "decisions.validation": "Selecciona una opci\u00f3n v\u00e1lida antes de continuar.",
  "decisions.error": "No se pudo registrar tu elecci\u00f3n ahora.",
  "decisions.externalReadOnly": "Esta decisi\u00f3n est\u00e1 controlada por el sistema responsable y aqu\u00ed est\u00e1 disponible solo para consulta.",
  "decisions.readOnly": "Esta decisi\u00f3n est\u00e1 disponible solo para consulta en este momento.",
  "decisions.selection": "Elecci\u00f3n registrada",
  "decisions.history": "Historial",
  "decisions.status.OPEN": "Esperando tu elecci\u00f3n",
  "decisions.status.DECIDED": "Decidida",
  "decisions.status.CANCELLED": "Cancelada",
  "decisions.status.SUPERSEDED": "Reemplazada",
  "decisions.history.OPENED": "Decisi\u00f3n abierta",
  "decisions.history.DECIDED": "Elecci\u00f3n registrada",
  "decisions.history.CANCELLED": "Decisi\u00f3n cancelada",
  "decisions.history.SUPERSEDED": "Decisi\u00f3n reemplazada",
  "activity.decision.selected": "Tu elecci\u00f3n fue registrada",

  // Layout grammar (V1 UI refresh)
  "layout.breadcrumb": "Ruta de navegación",
  "support.noMessages": "Aún no hay mensajes en este ticket.",
  "layout.filter": "Filtrar",
  "layout.filter.all": "Todos",
  "layout.filter.pending": "Pendientes",
  "layout.filter.inProgress": "En curso",
  "layout.filter.done": "Finalizados",
  "layout.context": "Información relacionada",
  "layout.noResults": "Ningún resultado para este filtro.",
  "layout.shortcuts": "Accesos rápidos",
  "layout.search": "Buscar por nombre",
  "layout.details": "Detalles",
  "layout.status": "Estado",
  "layout.createdAt": "Creada el",
  "layout.completedAt": "Completada el",
  "common.viewAll": "Ver todo",
  "projects.estimate": "Previsión",
  "projects.deliverablesEmpty": "Aún no hay entregas publicadas.",
  "proposals.items": "Ítems de la propuesta",
  "questionnaires.answers": "Tus respuestas",
  "support.channels": "Otros canales",
  "home.pulse.label": "Resumen rápido",
  "home.pulse.actions": "acciones pendientes",
  "home.pulse.inProgress": "proyectos y servicios activos",
  "home.pulse.openInvoices": "facturas abiertas",
  "home.pulse.overdue.one": "facturas abiertas · {count} vencida",
  "home.pulse.overdue.other": "facturas abiertas · {count} vencidas",
  "home.pulse.tickets": "tickets activos",
  "home.pulse.waitingYou.one": "tickets activos · {count} te espera",
  "home.pulse.waitingYou.other": "tickets activos · {count} te esperan",
  "publicHome.feature.projects": "Etapas, entregas y aprobaciones de tus proyectos",
  "publicHome.feature.billing": "Facturas y pagos con estado en tiempo real",
  "publicHome.feature.support": "Soporte con historial completo de conversaciones",
} satisfies Record<keyof typeof ptBR, string>;

export type TranslationKey = keyof typeof ptBR;
export type Locale = "pt-BR" | "en" | "es";

export const catalogs: Readonly<Record<Locale, Readonly<Record<string, string>>>> = {
  "pt-BR": ptBR,
  en,
  es,
};
